import React, { useEffect, useState } from "react";
import AdvisorNavbar from "../../../components/navbar/AdvisorNavbar";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Tooltip,
  Typography,
  MenuItem,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Popper,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { styled } from "@mui/material/styles";
import { Controller, useForm } from "react-hook-form";
import { Country, State, City } from "country-state-city";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import QualificationDetails from "./sections/QualificationDetails/QualificationDetails";
import { useNavigate } from "react-router-dom";
import ViewTaskDataGrid from "./sections/ViewTasks";
import ViewNotesDataGrid from "../notes/EnquiryNotes";
import EnquiryBookDemoForm from "../../../views/advisor/leadpages/EnquiryBookaDemo";
import CreatePopup from "../../../components/dialog/CreatePopup";
import DemoHistoryItem from "../../../newTestPrep/pages/enquiry/DemoHistoryItem";
import DemoHistoryList from "../../../newTestPrep/pages/enquiry/DemoHistoryList";
import EnquiryRescheduleDemoForm from "../../../views/advisor/leadpages/EnquiriesRescheduleDemo";
import axios from "axios";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import TaskDataGrid from "../../../section/tasks/AdvisorTaskDataGrid";
import EnquiryPayments from "./sections/payments/EnquiryPayments";
import DropOutRequest from "./sections/dropout/DropOutRequest";
import ViewClassHistory from "./sections/classes/ViewClassHistory";
import WhatsappMessages from "./sections/whatsapp/WhatsappMessages";
import CampaignDetail from "./sections/CampaignDetail/CampaignDetail";
import Email from "./sections/Email/Email";
import EventRegistration from "./sections/EventRegstration/EventRegistration";
import CustomPopup from "../../../components/CustomPopup";
import GradlynkForm from "./Gradlynk/GradlynkForm";
import GradlynkServicesTable from "./Gradlynk/GradlynkServicesTable";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { Link } from "react-scroll";
import { DataGrid } from "@mui/x-data-grid";
import { useId } from "react";
import QualificationModal from "../components/QualificationModal";

import {
  emailPattern,
  emailWithRequiredPattern,
  fDateTime,
  fTimestamp,
  namePattern,
  nameWithRequiredPattern,
  validateMobile,
} from "../../../utils/formatTime";
import SubServiceDetails from "./SubServiceDetails/SubServiceDetails";
import CustomTextFieldComp from "../../../newTestPrep/newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../newTestPrep/newComponent/AutocompleteComp";
import AddMoreServiceForm from "./AddMoreServiceForm";
import AddMiscellaneousFees from "./sections/payments/AddMiscellaneousFees";
import ApproveCashDeposits from "../../../newTestPrep/pages/payments/ApproveCashDeposits";
import ApproveIcon from "../../../newTestPrep/newComponent/iconsComp/ApproveIcon";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { useGetTokenOrLogout } from "../../../utils/token";
import ViewProgramHistory from "./sections/programs/ViewProgramHistory";
import GradlynkStages from "./Gradlynk/GrandlynkStages";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: `2px solid #2196F3`,
  borderRadius: "10px",
}));

const BodyContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  overflowY: "auto", // Enable vertical scrolling for the content
  height: "calc(100vh - 50px)", // Subtract header height
}));

function ViewEnquiry({
  enquiryData,
  headerHeight,
  enquiryPersonalDetails,
  qualificationList,
  setQualificationList,
}) {
  console.log("enquiryPersonalDetails", enquiryPersonalDetails);
  const navigate = useNavigate();
  const [openQualification, setOpenQualification] = useState(false);

  const [qualificationData, setQualificationData] = useState({
    highestQualification: "",
    qualificationName: "",
    stream: "",
    duration: "",
    country: "",
    state: "",
    city: "",
    affiliation: "",
    institution: "",
    educationStatus: "",
    year: "",
    cgpa: "",
    percentage: "",
    credits: "",
    backlogs: "",
    eca: "",
  });

  const [courseLevels, setCourseLevels] = useState([]);
  const [streams, setStreams] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [qualificationStates, setQualificationStates] = useState([]);
  const [qualificationCities, setQualificationCities] = useState([]);
  const [affiliations, setAffiliations] = useState([]);

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
    trigger,
    getValues,
  } = useForm({
    defaultValues: {
      first_name: enquiryData?.first_name || "", // set initial default here
      last_name: enquiryData?.last_name || "", // set initial default here
      email: enquiryData?.email || "",
      mobile_country_code: enquiryData?.mobile_country_code,
      mobile: enquiryData?.mobile || "",
      whatsapp_country_code: enquiryData.whatsapp_country_code || "",
      whatsapp_number: enquiryData.whatsapp_number || "",
      secondary_mobile_country_code:
        enquiryData.secondary_mobile_country_code || "",
      secondary_mobile: enquiryData.secondary_mobile || "",
      // Guardian Mobile
      guardian_mobile_country_code:
        enquiryData?.guardian_mobile_country_code || "",
      guardian_mobile: enquiryData?.guardian_mobile || "",
      secondary_email: enquiryData.secondary_email || "",
      sub_service_id: enquiryData.sub_service_id?.id || null,
      test_type_id:
        enquiryData.test_type_id?.id || enquiryData.test_type_id || null,
      country_id: enquiryData.country_id?.id || enquiryData.country_id || null,
      preferred_delivery_mode: enquiryData.preferred_delivery_mode,
      sub_test_type_id:
        enquiryData.sub_test_type_id?.id ||
        enquiryData.sub_test_type_id ||
        null,
      test_delivery_format_id:
        enquiryData.test_delivery_format_id?.id ||
        enquiryData.test_delivery_format_id ||
        null,
      exam_status_id: enquiryData.exam_status_id || null,
      prospective_level_id:
        enquiryData.prospective_level_id?.id ||
        enquiryData.prospective_level_id ||
        null,
      premium_admission_programs_id:
        enquiryData.premium_admission_programs_id?.id ||
        enquiryData.premium_admission_programs_id ||
        null,
      nearest_branch_id: enquiryData.nearest_branch_id?.id || null,
      lead_source_type_id: enquiryData.lead_source_type_id?.id || null,
      sub_lead_source_type_id:
        enquiryData.sub_lead_source_type_id?.id ||
        enquiryData.sub_lead_source_type_id ||
        null,
      // ...other fields
    },
  });

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const enquiryId = enquiryData?.id || null;
  const advisorId = localStorage.getItem("advisorId");
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();
  const employeeCountry = localStorage.getItem("employeeCountry");
  console.log("employeeCountry", employeeCountry);
  const [role, setRole] = useState(userRole);

  const [isWhatsappChecked, setIsWhatsappChecked] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [taskItems, setTaskItems] = useState([]);
  const [advisors, setAdvisors] = useState([]);
  const [notes, setNotes] = useState("");
  const [notesData, setNotesData] = useState([]);
  const [tasksData, setTasksData] = useState([]);
  const [isDemoPopupOpen, setIsDemoPopupOpen] = useState(false);
  const [isRescheduleDemoPopupOpen, setIsRescheduleDemoPopupOpen] =
    useState(false);
  const [branches, setBranches] = useState([]);
  const [demoHistory, setDemoHistory] = useState([]);
  const [payments, setPayments] = useState([]);
  const [miscellaneousPayment, setMiscellaneousPayment] = useState([]);
  const [miscellaneousPaymentLoading, setMiscellaneousPaymentLoading] =
    useState([]);
  const [classes, setClasses] = useState([]);
  const [testtypes, setTestTypes] = useState([]);
  const [subTestType, setSubtestType] = useState([]);
  const [subTestTypeFormat, setSubtestTypeFormat] = useState([]);
  const [users, setUsers] = useState([]);
  const [taskOwners, setTaskOwners] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [subLeadSources, setSubLeadSources] = useState([]);
  const [assignTo, setAssignTo] = useState(null);
  const [referenceByList, setReferenceByList] = useState([]);
  const [referenceBy, setReferenceBy] = useState(null);
  const [countryList, setcountryList] = useState([]);
  const [noteLoading, setNoteLoading] = useState(false);
  const [noteList, setNotesList] = useState([]);

  const [openQualificationModal, setOpenQualificationModal] = useState(false);
  const [selectedQualification, setSelectedQualification] = useState(null);

  const [isAddFeePopup, setIsAddFeePopup] = useState(false);
  const [branchId, setBranchId] = useState(
    enquiryData.nearest_branch_id?.id || null,
  );
  const [selectedCountry, setSelectedCountry] = useState(
    enquiryData.country_id?.id || enquiryData.country_id || null,
  );
  const [selectedState, setSelectedState] = useState(
    enquiryData.state_id?.id || enquiryData.state_id || null,
  );
  const [selectedCity, setSelectedCity] = useState(
    enquiryData.city_id?.id || enquiryData.city_id || null,
  );
  const [selectedService, setSelectedService] = useState(
    enquiryData.service_id?.id || null,
  );
  const [selectedSubService, setSelectedSubService] = useState(
    enquiryData.sub_service_id?.id || null,
  );
  const [selectedSourceType, setSelectedSourceType] = useState(
    enquiryData.lead_source_type_id?.id || null,
  );

  const [recycleReasonId, setRecycleReasonId] = useState(null);
  const [recycleRequestLoading, setRecycleRequestLoading] = useState(false);

  const [maritalStatus, setMaritalStatus] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [services, setServices] = useState([]);
  const [subServices, setSubServices] = useState([]);
  const [sourceTypes, setSourceTypes] = useState([]);
  const [subSourceTypes, setSubSourceTypes] = useState([]);
  const [purposeOfTest, setPurposeOfTest] = useState([]);
  const [leadTestExperience, setLeadTestExperience] = useState([]);
  const [examStatuses, setExamStatus] = useState([]);
  const [proficiencyLevel, setProficiencyLevel] = useState([]);
  const [prospectiveLevel, setProspectiveLevel] = useState([]);
  const [levelOfInterest, setLevelOfInterest] = useState([]);
  const [targetCountries, setTargetCountries] = useState([]);
  const [recycledReasons, setRecycleReasons] = useState([]);
  const [selectedTestTypeId, setSelectedTestTypeId] = useState();
  const [subServicesPrograms, setSubServicesPrograms] = useState([]);
  const [assignmentType, setAssignmentType] = useState(null);
  const [isDropOutRequest, setIsDropOutRequest] = useState(false);
  const [studentInfo, setStudentInfo] = useState(enquiryData || {});
  const [demoHistoryExpanded, setDemoHistoryExpanded] = useState(false);
  const [activityExpanded, setActivityExpanded] = useState(true);
  const [addServicePopup, setAddservicePopup] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [programLoading, setProgramLoading] = useState(false);
  const [showPrograms, setShowPrograms] = useState(false);
  const [alluserlist, setAllUserList] = useState([]);

  const handleDemoHistoryAccordionChange = () => {
    setDemoHistoryExpanded(!demoHistoryExpanded);
  };

  const handleActivityAccordionChange = () => {
    setActivityExpanded(!activityExpanded);
  };

  const examStatus = watch("exam_status_id");
  const testBooking = watch("test_taken");
  const deliveryMode = watch("delivery_mode");

  const recycledReason = watch("prospective_level_id");

  const [examStatusId, setExamStatusId] = useState(
    enquiryData.exam_status_id || null,
  );

  const [prospectiveLevelId, setProspectiveLevelId] = useState(
    enquiryData.prospective_level_id?.id || null,
  );

  const [pinCodeData, setPinCodeData] = useState({});
  const [pinCode, setPinCode] = useState(enquiryData.pincode || null);
  const [pincodeError, setPincodeError] = useState("");
  const [nearest_branch, setNearestBranch] = useState(
    enquiryData.nearest_branch_id?.id || null,
  );

  const handleAddQualification = () => {
    setQualificationData({
      highestQualification: "",
      qualificationName: "",
      stream: "",
      duration: "",
      country: "",
      state: "",
      city: "",
      affiliation: "",
      institution: "",
      educationStatus: "",
      year: "",
      cgpa: "",
      percentage: "",
      credits: "",
      backlogs: "",
      eca: "",
    });

    setSelectedQualification(null);
    setOpenQualificationModal(true);
  };

  const handleEditQualification = (row) => {
    console.log("chitra", row);
    setQualificationData({
      highestQualification: row.highest_qualification_id,
      qualificationName: row.qualification_name,
      stream: row.stream_id,
      duration: row.duration,
      country: row.country_id,
      state: row.state_id,
      city: row.city_id,
      affiliation: row.affiliation_id,
      institution: row.institution_name,
      educationStatus: row.education_status,
      year: row.year_of_passing,
      cgpa: row.cgpa,
      percentage: row.percentage,
      credits: row.credits,
      backlogs: row.backlogs,
      eca: row.eca,
    });

    fetch(`${API_ENDPOINT}oldstate`)
      .then((res) => res.json())
      .then((data) => {
        console.log("row.country_id =", row.country_id);
        console.log("total states =", data.length);

        const filtered = data.filter(
          (x) => Number(x.country_id) === Number(row.country_id),
        );

        console.log("filtered states =", filtered);

        setQualificationStates(filtered);
      });

    fetch(`${API_ENDPOINT}oldcity`)
      .then((res) => res.json())
      .then((data) => {
        setQualificationCities(
          data.filter(
            (x) =>
              Number(x.country) === Number(row.country_id) &&
              Number(x.state) === Number(row.state_id),
          ),
        );
      });

    fetch(
      `${API_ENDPOINT}affiliations?country_id=${row.country_id}&state_id=${row.state_id}`,
    )
      .then((res) => res.json())
      .then((data) => setAffiliations(data));

    setSelectedQualification(row);

    setOpenQualificationModal(true);
  };

  const handleDeleteQualification = async (id) => {
    try {
      const response = await fetch(
        `${API_ENDPOINT}qualificationDetails/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updated_by: Number(userId),
          }),
        },
      );

      if (response.ok) {
        const updatedQualifications =
          await fetchQualificationDetails(enquiryId);

        setQualificationList(updatedQualifications);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleCloseQualification = () => {
    setOpenQualificationModal(false);
  };

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [changes, setChanges] = useState({});
  const [showMobile, setShowMobile] = useState(false);
  const [showSecondaryMobile, setShowSecondaryMobile] = useState(false);
  const [showWhatsAppNumber, setShowWhatAppNumber] = useState(false);
  const [mobileLoading, setMobileLoading] = useState(false);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const [showPayment, setShowPayment] = useState(false);
  const [showClasses, setShowClasses] = useState(false);
  const [showSuservice, setShowSubservice] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [classLoading, setClassLoading] = useState(false);

  const [isSendTestLink, setIsSendTestLink] = useState("no");
  const [gradlynkpopup, setGradlynkpopup] = useState(false);

  const [showGradlynkService, setShowGradlynkService] = useState(false);
  const [showAssignHistory, setShowAssignHistory] = useState(false);
  const [assignData, setAssignData] = useState([]);
  const [showGradlynkStages, setShowGradlynkStages] = useState(false);

  const handleToggleAssign = () => {
    setShowAssignHistory(!showAssignHistory);
  };

  useEffect(() => {
    fetchCourseLevels();
    fetchStreams();
    fetchCountries();
    fetchAffiliations();
  }, []);

  useEffect(() => {
    fetch(`${API_ENDPOINT}route2.0/assigntohistory/${enquiryId}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      })
      .then((data) => {
        if (!data) return; // Stop further execution if data is not present

        const sortedData = data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setAssignData(sortedData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [enquiryId]);

  const handleOpenAddFeePopup = () => {
    if (![4, 9, 5, 7].includes(studentInfo?.sub_service_id?.id)) {
      showSnackbar(
        "Miscellaneous revenue can only be collected for PTE , TOEFL ,Duolingo And GRE Sub service",
        "error",
      );
      return;
    }
    setIsAddFeePopup(true);
  };

  const handleCloseAddFeePopup = () => {
    setIsAddFeePopup(false);
  };

  const handleGrandlynkPopupOpen = () => {
    setGradlynkpopup(true);
  };

  const handleGrandlynkPopupclose = () => {
    setGradlynkpopup(false);
  };
  const handleSendTestLinkChange = (event) => {
    setIsSendTestLink(event.target.value);
  };

  const handlePaymentHistoryClick = () => {
    setShowPayment(!showPayment);
  };

  const handleClassHistoryClick = () => {
    setShowClasses(!showClasses);
  };

  const handleProgramHistoryClick = () => {
    setShowPrograms(!showPrograms);
  };

  const handlesubServiceHistoryClick = () => {
    setShowSubservice(!showSuservice);
  };
  const handleGradlynkServiceClick = () => {
    setShowGradlynkService(!showGradlynkService);
  };

  const handleGrandLynkStagesClick = () => {
    setShowGradlynkStages(!showGradlynkStages);
  };

  const isBookDemoDisabled = demoHistory.length === 0;
  const isRescheduleDemoDisabled = demoHistory.some(
    (item) => item.status === "pending" || item.status === "confirmed",
  );

  const isEnrollStudentDisabled =
    enquiryData?.student_id?.status_of_student == "active";

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
    setValue("country_id", event.target.value);
    setStudentInfo({ ...studentInfo, country_id: event.target.value });
    handleFieldChange("country_id", event.target.value);
  };

  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
    setValue("state_id", event.target.value);
    setStudentInfo({ ...studentInfo, state_id: event.target.value });
    handleFieldChange("state_id", event.target.value);
  };

  const handleCityChange = (event) => {
    setSelectedCity(event.target.value);
    setValue("city_id", event.target.value);
    setStudentInfo({ ...studentInfo, city_id: event.target.value });
    handleFieldChange("city_id", event.target.value);
  };

  const handleServiceChange = (event) => {
    setSelectedService(event.target.value);
    setValue("service_id", event.target.value);
    setStudentInfo({ ...studentInfo, service_id: event.target.value });
    handleFieldChange("service_id", event.target.value);
  };

  const handleSubServiceChange = (event) => {
    setSelectedSubService(event.target.value);
    setValue("sub_service_id", event.target.value);
    setStudentInfo({ ...studentInfo, sub_service_id: event.target.value });
    handleFieldChange("sub_service_id", event.target.value);

    setValue("premium_admission_programs_id", null);
    setStudentInfo({ ...studentInfo, premium_admission_programs_id: null });
    handleFieldChange("premium_admission_programs_id", null);
  };

  const handleSourceTypeChange = (event) => {
    setSelectedSourceType(event.target.value);
    setValue("lead_source_type_id", event.target.value);
    setStudentInfo({ ...studentInfo, lead_source_type_id: event.target.value });
    handleFieldChange("lead_source_type_id", event.target.value);
  };

  const handleExamStatusChange = (value) => {
    setExamStatusId(value);
    setValue("exam_status_id", value);
    setStudentInfo({ ...studentInfo, exam_status_id: value });
  };

  const handleProspectiveLevelChange = (value) => {
    setProspectiveLevelId(value);
    setValue("prospective_level_id", value);
    setStudentInfo({ ...studentInfo, prospective_level_id: value });
  };

  const handleRecycleReasonChange = (value) => {
    setRecycleReasonId(value);

    //setValue('prospective_level_id', value);
    // setStudentInfo({ ...studentInfo, prospective_level_id: value })
    const recycleReasonRequest = async (value) => {
      setRecycleRequestLoading(true);
      const requestData = {
        enquiry_id: enquiryId,
        request_reason_id: value,
        user_id: userId,
      };
      try {
        const response = await fetch(`${API_ENDPOINT}recyclerequest`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        // .then((response) => {
        if (response.status === 201) {
          showSnackbar("Recycle Request sent to data entry", "success");
          console.log("Recycle Request successfully", JSON.stringify(response));
          console.log("Form reset successfully");
          setRecycleRequestLoading(false);
          setTimeout(() => {
            navigate("/enquiries");
          }, 4000);
        } else if (response.status === 409) {
          showSnackbar("Recycle Request Exists For this Enquiry", "error");
          setRecycleRequestLoading(false);
        } else {
          showSnackbar(
            "Error submitting recycle request. Please try again.",
            "error",
          );
          setRecycleRequestLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        // alert('An error occurred. Please try again later.');
        showSnackbar(
          "An error occurred submiting the recycle request. Please try again later.",
          "error",
        );
        setRecycleRequestLoading(false);
      }
    };
    recycleReasonRequest(value);
  };

  //logic for test booking input
  const handleTestBookingStatusChange = (value) => {
    setValue("test_taken", value);
    setStudentInfo({ ...studentInfo, test_taken: value });
  };

  const handleOpenDemoPopup = () => {
    if (studentInfo?.sub_service_id === null) {
      showSnackbar("Please add sub service first", "error");
      return;
    }
    if (studentInfo?.service_id?.id !== 1) {
      showSnackbar(
        `Can't book demo with  ${studentInfo?.service_id?.service_name} service`,
        "error",
      );
      return;
    }
    setIsDemoPopupOpen(true);
  };

  const handleCloseDemoPopup = () => {
    setIsDemoPopupOpen(false);
  };

  const handleOpenRescheduleDemoPopup = () => {
    if (studentInfo?.sub_service_id === null) {
      showSnackbar("Plese add subservice first", "error");
      return;
    }
    if (studentInfo?.service_id?.id !== 1) {
      showSnackbar(
        `Can't reschedule  demo with  ${studentInfo?.service_id?.service_name} service`,
        "error",
      );
      return;
    }
    setIsRescheduleDemoPopupOpen(true);
  };

  const handleCloseRescheduleDemoPopup = () => {
    setIsRescheduleDemoPopupOpen(false);
  };

  const handleOpenDropOutRequest = () => {
    setIsDropOutRequest(true);
  };

  const handleCloseDropOutRequest = () => {
    setIsDropOutRequest(false);
  };

  const handleLeadSourceTypeChange = (selectedType) => {
    // Filter sub lead sources based on the selected lead source type category
    const filteredSubLeadSources = leadSources.filter(
      (source) => source.category === selectedType,
    );
    setSubLeadSources(filteredSubLeadSources);
  };

  const handleFieldChange = (fieldName, value) => {
    // Update the changes object
    setChanges((prevChanges) => ({
      ...prevChanges,
      [fieldName]: value,
    }));
  };

  const copyLinkToClipboard = () => {
    const link = "http://164.52.208.95:4002/test";
    navigator.clipboard
      .writeText(link)
      .then(() => {
        console.log("Link copied to clipboard:", link);
        showSnackbar("Link copied to clipboard", "success");
      })
      .catch((error) => {
        console.error("Error copying link to clipboard:", error);
        showSnackbar("Error copying link to clipboard:", "error");
      });
  };

  const handleSendEvaluationLink = async (data) => {
    try {
      const response = await fetch(`${API_ENDPOINT}evaluationlink`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: enquiryId }),
      });
      // .then((response) => {
      if (response.status === 200) {
        showSnackbar("Link sent successfully", "success");
        console.log("Enquiry sent successfully", JSON.stringify(response));
        console.log("Form reset successfully");
      } else {
        showSnackbar("Error submitting enquiry. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error:", error);
      // alert('An error occurred. Please try again later.');
      showSnackbar("An error occurred. Please try again later.", "error");
    }
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}leadsource`)
      .then((response) => response.json())
      .then((data) => {
        setLeadSources(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching leadsource:", error);
      });
  }, []);

  const handlePinCodeChange = (event) => {
    const newPinCode = event.target.value;
    setStudentInfo({ ...studentInfo, pincode_id: newPinCode });
  };

  const fetchPinCodeData = async (pincode) => {
    try {
      const response = await axios.get(
        `${API_ENDPOINT}route/detailbypincode/${pincode}`,
      );
      if (response.status === 200) {
        return response.data;
      } else {
        console.log("Invalid pincode");
        setPincodeError("Invalid pin code");
        setNearestBranch(null);
        return null;
      }
    } catch (error) {
      console.error("Error fetching pin code data:", error);
      setPincodeError("Error fetching pinCode data");
      setNearestBranch(null);
      return null;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pinCodeData = await fetchPinCodeData(studentInfo.pincode);

        if (pinCodeData) {
          setPincodeError("");

          setNearestBranch(pinCodeData.branch_detail[0].id);

          setBranchId(pinCodeData.branch_detail[0].id);

          setStudentInfo((prevStudentInfo) => ({
            ...prevStudentInfo,
            state: pinCodeData.state,
            city: pinCodeData.city,
            nearest_branch: pinCodeData?.branch_detail[0].id,
          }));

          setChanges((prevStudentInfo) => ({
            ...prevStudentInfo,
            pincode: studentInfo.pincode,
            state: pinCodeData.state,
            city: pinCodeData.city,
            nearest_branch: pinCodeData?.branch_detail[0].id,
          }));
        } else {
          setPincodeError("Invalid pin code");
          setNearestBranch(null);
          // handle other state resets if needed
        }
      } catch (error) {
        console.error("Error fetching pin code data:", error);
        setPincodeError("Error fetching pin code data");
        setNearestBranch(null);
        showSnackbar("Error fetching pin code data", "error");
        // handle other state resets if needed
      }
    };

    if (studentInfo.pincode?.length === 6) {
      fetchData();
    }
  }, [studentInfo.pincode]);

  const handlePinCodeChange2 = (event) => {
    const newPinCode = event.target.value;
    if (newPinCode.length === 6) {
      setValue("pincode_id", newPinCode);
      fetchPinCodeData2(newPinCode);
    } else {
      setPincodeError("Invalid pin code 3");

      setSelectedState(null);
      setSelectedCity(null);
      setValue("pincode_id", null);
      setValue("state_id", null);
      setValue("city_id", null);
      // setValue('nearest_branch', null);
    }
  };

  const fetchPinCodeData2 = async (pincode) => {
    try {
      const response = await axios.get(
        `${API_ENDPOINT}oldzipcode/pincode/${pincode}`,
      );
      //setPinCodeData(response.data);
      if (response.status === 200) {
        const postOfficeData = response.data; // Get the first PostOffice object
        setPinCodeData(postOfficeData);
        console.log(postOfficeData);
        if (postOfficeData) {
          // Update the State and City fields with the data from the API
          handleFieldChange("pincode_id", pincode);
          setPincodeError("");
          setSelectedState(parseInt(postOfficeData.state_id));
          setValue("state_id", parseInt(postOfficeData.state_id));
          handleFieldChange("state_id", parseInt(postOfficeData.state_id));

          setSelectedCity(parseInt(postOfficeData.city_id));
          setValue("city_id", parseInt(postOfficeData.city_id));
          handleFieldChange("city_id", parseInt(postOfficeData.city_id));
          // setValue('nearest_branch', postOfficeData?.branch_detail[0]?.id);
        }
      } else {
        console.log("Invalid pincode");
        console.log("API error");
        //alert('error')
        setPincodeError("Invalid pin code 1");
        //setNearestBranch(null)
        setError("pincode", { type: "manual", message: "Invalid pin code 2" });
        /* reset({
                state: '',
                city: '',
                nearest_branch: null
            })*/
        setValue("pincode_id", null);
        setValue("state_id", "");
        setValue("city_id", "");
        setSelectedState(null);
        setSelectedCity(null);
        //setValue('nearest_branch', null);
      }
    } catch (error) {
      console.error("Error fetching pin code data:", error);
      showSnackbar("Error fetching pin code data", "error");
      setPinCodeData(null);
    }
  };

  //logic for save button
  const handleSaveStudentInfo = async () => {
    /* const validationFields = ['mobile', 'whatsapp_number', 'email'];
          const isValid = await trigger(validationFields);

          if (!isValid) {
            validationFields.forEach((field) => {
              const error = getValues(field) ? errors[field]?.message : 'Field is required';
              setValue(field, getValues(field)); // Reset the field value to trigger re-render with error message
              console.error(`Validation failed for ${field}: ${error}`);
            });
      
            console.error('Validation failed. Please check the entered values.');
            return;
          }*/
    if (assignmentType === "co_assignee") {
      studentInfo.co_assignee = assignTo;
    } else {
      studentInfo.assign_to = assignTo;
    }

    studentInfo.nearest_branch = branchId;
    studentInfo.user_id = parseInt(userId);
    changes.user_id = parseInt(userId);

    updateSectionData(changes, "student_info");

    setChanges({});
  };

  //put api request for updating information with save
  const updateSectionData = (sectionData, sectionName) => {
    fetch(`${API_ENDPOINT}lmenquirycrm/${enquiryId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(sectionData),
    })
      .then(async (response) => {
        if (response.ok) {
          showSnackbar(`Data updated successfully`, "success");
          setTimeout(() => {
            window.location.reload();
          }, 1500);
          return;
        }
        const data = await response.json();
        if (response.status == 409) {
          showSnackbar(
            "A duplicate Sub Service already exists for this lead. Please check and try again",
            "error",
          );
        } else if (response.status == 400) {
          showSnackbar(data.message || "Validation error", "error");
        } else {
          // Handle errors here
          console.error(`Error updating data for ${sectionName}`);
          showSnackbar(`Error updating data for ${sectionName}`, "error");
          //alert('Error updating data')
        }
      })
      .catch((error) => {
        console.error("API request error:", error);
        showSnackbar("Network Error", "error");
        //alert('Network Error')
      });
  };

  // Function to open the dialog for add task
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  // Function to close the dialog
  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  //logic for add note button
  const noteSubmit = () => {
    const requestData2 = {
      note: notes,
      advisor_id: advisorId,
      student_id: enquiryId,
    };

    fetch(`${API_ENDPOINT}note`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData2),
    })
      .then((response) => {
        if (response.status === 201) {
          alert("Note added successfully");
          setNotes("");
        } else {
          // API call failed, show error message
          alert("Error adding note. Please try again.");
        }
      })
      .catch((error) => {
        // Handle network errors or other issues
        console.error("Error:", error);
        alert("An error occurred. Please try again later.");
      });
  };

  useEffect(() => {
    // Fetching countries and set initial value
    const countries = Country.getAllCountries();
    setValue("country", "IN");

    //Fetching states and set initial value
    const states = State.getStatesOfCountry(selectedCountry);
    //setValue('state', states[0]?.isoCode || '');

    //Fetching cities and set the initial value
    const cities = City.getCitiesOfState(selectedCountry, selectedState);
    //setValue('city', cities[0]?.name || '');
  }, [setValue, selectedCountry, selectedState]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}maritalstatuses`)
      .then((response) => response.json())
      .then((data) => {
        setMaritalStatus(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching maritalstatus:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code,
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.phone_code === obj.phone_code),
        );
        setcountryList(data);
        setCountries(uniqueArray);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      fetch(`${API_ENDPOINT}oldstate`)
        .then((response) => response.json())
        .then((data) => {
          const filteredState = data.filter(
            (state) => state.country_id === selectedCountry,
          );
          setStates(filteredState);
          console.log(filteredState);
        })
        .catch((error) => {
          console.error("Error fetching state:", error);
        });
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedCountry && selectedState) {
      fetch(`${API_ENDPOINT}oldcity`)
        .then((response) => response.json())
        .then((data) => {
          const filteredCity = data.filter(
            (city) =>
              city.country === selectedCountry && city.state === selectedState,
          );
          setCities(filteredCity);
          console.log(filteredCity);
        })
        .catch((error) => {
          console.error("Error fetching city:", error);
        });
    }
  }, [selectedCountry, selectedState]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}targetcountries`)
      .then((response) => response.json())
      .then((data) => {
        setTargetCountries(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching target countries:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}service`)
      .then((response) => response.json())
      .then((data) => {
        setServices(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, []);

  console.log("sublead", enquiryData.lead_source_type_id?.id);
  useEffect(() => {
    if (selectedService) {
      fetch(`${API_ENDPOINT}subservice`)
        .then((response) => response.json())
        .then((data) => {
          const filteredSubServices = data.filter(
            (sub) => sub.service_id === selectedService,
          );
          setSubServices(filteredSubServices);
          console.log(filteredSubServices);
        })
        .catch((error) => {
          console.error("Error fetching sub services:", error);
        });
    }
  }, [selectedService]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    if (selectedSubService) {
      fetch(`${API_ENDPOINT}subservice-program`)
        .then((response) => response.json())
        .then((data) => {
          const filteredPrograms = data.filter(
            (program) => program.sub_service_id === selectedSubService,
          );
          setSubServicesPrograms(filteredPrograms);
        })
        .catch((error) => {
          console.error("Error fetching services:", error);
        });
    }
  }, [selectedSubService]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}purposeoftest`)
      .then((response) => response.json())
      .then((data) => {
        setPurposeOfTest(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching purpose of test:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}leadtestexperience`)
      .then((response) => response.json())
      .then((data) => {
        setLeadTestExperience(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching test experience:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}examstatus`)
      .then((response) => response.json())
      .then((data) => {
        setExamStatus(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching exam status:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}levelofinterest`)
      .then((response) => response.json())
      .then((data) => {
        setLevelOfInterest(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching level of interest:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}proficiencylevel`)
      .then((response) => response.json())
      .then((data) => {
        setProficiencyLevel(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching proficiency level:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}prospectivelevel`)
      .then((response) => response.json())
      .then((data) => {
        setProspectiveLevel(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching prospective level:", error);
      });
  }, []);

  const fetchCourseLevels = async () => {
    try {
      const res = await fetch(`${API_ENDPOINT}gradlynkCourseLevel`);
      const data = await res.json();
      setCourseLevels(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleQualificationCountryChange = async (e) => {
    const countryId = e.target.value;

    setQualificationData((prev) => ({
      ...prev,
      country: countryId,
      state: "",
      city: "",
      affiliation: "",
    }));

    const stateRes = await fetch(`${API_ENDPOINT}oldstate`);
    const states = await stateRes.json();

    setQualificationStates(
      states.filter((x) => Number(x.country_id) === Number(countryId)),
    );

    setQualificationCities([]);
    setAffiliations([]);
  };

  const handleQualificationStateChange = async (e) => {
    const stateId = e.target.value;

    setQualificationData((prev) => ({
      ...prev,
      state: stateId,
      city: "",
      affiliation: "",
    }));

    const cityRes = await fetch(`${API_ENDPOINT}oldcity`);
    const cities = await cityRes.json();

    setQualificationCities(
      cities.filter(
        (x) =>
          Number(x.country) === Number(qualificationData.country) &&
          Number(x.state) === Number(stateId),
      ),
    );

    fetchAffiliations(qualificationData.country, stateId);
  };

  const fetchStreams = async () => {
    try {
      const res = await fetch(`${API_ENDPOINT}streams`);
      const data = await res.json();
      setStreams(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchCountries = async () => {
    try {
      const res = await fetch(`${API_ENDPOINT}country`);
      const data = await res.json();

      setCountriesList(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAffiliations = async (countryId = null, stateId = null) => {
    try {
      let url = `${API_ENDPOINT}affiliations`;

      if (countryId && stateId) {
        url += `?country_id=${countryId}&state_id=${stateId}`;
      }

      const res = await fetch(url);
      const data = await res.json();

      setAffiliations(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchQualificationDetails = async (enqId) => {
    try {
      const response = await fetch(
        `${API_ENDPOINT}qualificationDetails/${enqId}`,
      );

      if (!response.ok) {
        throw new Error("Unable to fetch qualifications");
      }

      return await response.json();
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const handleQualificationSave = async () => {
    if (!qualificationData.highestQualification) {
      alert("Highest Qualification is required.");
      return;
    }

    if (!qualificationData.stream) {
      alert("Stream is required.");
      return;
    }

    if (!qualificationData.country) {
      alert("Country is required.");
      return;
    }

    if (!qualificationData.institution?.trim()) {
      alert("Institution Name is required.");
      return;
    }

    if (!qualificationData.educationStatus) {
      alert("Education Status is required.");
      return;
    }

    if (
      qualificationData.educationStatus === "Complete" &&
      !qualificationData.year
    ) {
      alert("Year of Passing is required.");
      return;
    }
    const url = selectedQualification
      ? `${API_ENDPOINT}qualificationDetails/${selectedQualification.id}`
      : `${API_ENDPOINT}qualificationDetails`;

    const method = selectedQualification ? "PUT" : "POST";
    const userId = localStorage.getItem("userId");

    const body = {
      enq_id: enquiryId,

      highest_qualification_id: qualificationData.highestQualification,

      qualification_name: qualificationData.qualificationName,

      stream_id: qualificationData.stream,

      duration: qualificationData.duration,

      country_id: qualificationData.country,

      state_id: qualificationData.state,

      city_id: qualificationData.city,

      affiliation_id: qualificationData.affiliation,

      institution_name: qualificationData.institution,

      education_status: qualificationData.educationStatus,

      year_of_passing: qualificationData.year,

      cgpa: qualificationData.cgpa,

      percentage: qualificationData.percentage,

      credits: qualificationData.credits,

      backlogs: qualificationData.backlogs,

      eca: qualificationData.eca,

      updated_by: userId,
    };

    try {
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        setOpenQualificationModal(false);
        setSelectedQualification(null);

        const updatedQualifications =
          await fetchQualificationDetails(enquiryId);

        setQualificationList(updatedQualifications);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetch(`${API_ENDPOINT}leadsource`)
      .then((response) => response.json())
      .then((data) => {
        const filteredLeadSources = data.filter((sub) => sub.is_active === 1);
        console.log(filteredLeadSources);
        //setSubSourceTypes(filteredLeadSources);
        setLeadSources(filteredLeadSources);
      })
      .catch((error) => {
        console.error("Error fetching lead sources:", error);
      });
  }, []);

  useEffect(() => {
    if (selectedSourceType) {
      fetch(`${API_ENDPOINT}subleadsource`)
        .then((response) => response.json())
        .then((data) => {
          const filteredLeadSources = data.filter(
            (sub) => sub.lead_source_type_id === selectedSourceType,
          );
          setSubLeadSources(filteredLeadSources);
        })
        .catch((error) => {
          console.error("Error fetching sub lead sources:", error);
        });
    }
  }, [selectedSourceType]);

  // Fetch reference bY Api

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}referencewalkin`);
        if (response.ok) {
          const data = await response.json();
          console.log("data", data);

          setReferenceByList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}typeoftask`)
      .then((response) => response.json())
      .then((data) => {
        setTaskItems(data);
      })
      .catch((error) => {
        console.error("Error fetching task items:", error);
      });
  }, []);

  //fetching tasks for task input dropdown
  useEffect(() => {
    fetch(`${API_ENDPOINT}typeoftask`)
      .then((response) => response.json())
      .then((data) => {
        setTaskItems(data);
      })
      .catch((error) => {
        console.error("Error fetching task items:", error);
      });
  }, []);

  //fetching assign to dropdown menu

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}route/getalltesttype`)
      .then((response) => response.json())
      .then((data) => {
        setTestTypes(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  useEffect(() => {
    const testType = testtypes.find(
      (i) =>
        i.id === studentInfo.test_type_id?.id ||
        i.id === studentInfo.test_type_id,
    );
    setSelectedTestTypeId(testType);
  });

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}route2.0/getsubtesttype/${selectedTestTypeId?.id}`)
      .then((response) => response.json())
      .then((data) => {
        setSubtestType(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
        setSubtestType([]);
      });
  }, [selectedTestTypeId?.id]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}testdeliveryformat`)
      .then((response) => response.json())
      .then((data) => {
        setSubtestTypeFormat(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching testtypes:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}branch`)
      .then((response) => response.json())
      .then((data) => {
        setBranches(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}recyclereason`)
      .then((response) => response.json())
      .then((data) => {
        setRecycleReasons(data);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching recyclereason:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${API_ENDPOINT}advisor`)
      .then((response) => response.json())
      .then((data) => {
        setAdvisors(data);
      })
      .catch((error) => {
        console.error("Error fetching advisor items:", error);
      });
  }, []);

  useEffect(() => {
    fetch()
      .then((response) => response.json())
      .then((data) => {
        setNotesData(data);
      })
      .catch((error) => {
        console.error("Error fetching note items:", error);
      });
  }, [enquiryId]);

  useEffect(() => {
    fetch(`${API_ENDPOINT}advisordashboard/taskbystudent/${enquiryId}`)
      .then((response) => response.json())
      .then((data) => {
        setTasksData(data);
      })
      .catch((error) => {
        console.error("Error fetching task items:", error);
      });
  }, [enquiryId]);

  useEffect(() => {
    setDemoLoading(true);
    fetch(`${API_ENDPOINT}route/demohistory/${enquiryId}`)
      .then((response) => response.json())
      .then((data) => {
        data.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setDemoHistory(data);
        setDemoLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching demo items:", error);
        setDemoLoading(false);
      });
  }, [enquiryId]);

  useEffect(() => {
    setPaymentLoading(true);
    fetch(`${API_ENDPOINT}route/paymentforenquiry/${enquiryId}`)
      .then((response) => response.json())
      .then((data) => {
        data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setPayments(data);
        setPaymentLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching payments items:", error);
        setPaymentLoading(false);
      });
  }, [enquiryId]);

  useEffect(() => {
    setMiscellaneousPaymentLoading(true);
    fetch(`${API_ENDPOINT}route/miscellaneouspaymenthistory/${enquiryId}`)
      .then((response) => response.json())
      .then((data) => {
        data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setMiscellaneousPayment(data);
        setMiscellaneousPaymentLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching payments items:", error);
        setMiscellaneousPayment([]);
        setMiscellaneousPaymentLoading(false);
      });
  }, [enquiryId]);

  useEffect(() => {
    setClassLoading(true);
    fetch(`${API_ENDPOINT}route/stdclass/${enquiryId}`)
      .then((response) => response.json())
      .then((data) => {
        setClasses(data);
        setClassLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching classes items:", error);
        setClassLoading(false);
      });
  }, [enquiryId]);

  useEffect(() => {
    setProgramLoading(true);
    fetch(`${API_ENDPOINT}route/sapprogram/${enquiryId}`)
      .then((response) => response.json())
      .then((data) => {
        setPrograms(data);
        setProgramLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching program items:", error);
        setProgramLoading(false);
      });
  }, [enquiryId]);

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}route/getalluser`)
      .then((response) => response.json())
      .then((data) => {
        let filteredData = data.filter(
          (user) =>
            user.user_role === "advisor" ||
            user.user_role === "admin" ||
            user.user_role === "trainer",
        );

        if (role === "advisor" || role === "trainer") {
          // If the role is advisor, filter the list to show only the logged-in advisor
          filteredData = data.filter((user) => user.id === parseInt(userId));
        }

        const sortedData = filteredData.sort((a, b) => {
          const nameA = (a.first_name + " " + a.last_name).toUpperCase();
          const nameB = (b.first_name + " " + b.last_name).toUpperCase();
          return nameA.localeCompare(nameB);
        });

        const sortedData2 = data.sort((a, b) => {
          const nameA = (a.first_name + " " + a.last_name).toUpperCase();
          const nameB = (b.first_name + " " + b.last_name).toUpperCase();
          return nameA.localeCompare(nameB);
        });
        setUsers(sortedData);
        setTaskOwners(sortedData2);
        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const handleEnrollStudent = () => {
    if (userRole !== "advisor") {
      showSnackbar(
        "Please login as an advisor role,to enroll this student",
        "error",
      );
      return;
    }
    if (studentInfo?.sub_service_id === null) {
      showSnackbar("Plese add subservice first", "error");
      return;
    }
    const allowedServiceIds = [1, 2];

    if (!allowedServiceIds.includes(studentInfo?.service_id?.id)) {
      showSnackbar(
        `Can't enroll the student with ${studentInfo?.service_id?.service_name} service`,
        "error",
      );
      return;
    }
    // Navigate to the new route and pass enquiryData as state
    navigate("/enroll-student", { state: { enquiryData } });
  };

  const handleViewClassDetails = () => {
    // Navigate to the new route and pass enquiryData as state
    if (enquiryData.student_id) {
      navigate(`/view-student/${enquiryData?.student_id?.id}`);
    } else {
      navigate("/page404");
    }
  };

  const isRecycledReadonly = enquiryData.is_active === 0;
  const isServiceReadOnly =
    enquiryData?.service_id?.service_name !== "Undefined";
  const issubServiceReadOnly =
    enquiryData?.sub_service_id?.name !== "Undefined" &&
    enquiryData?.sub_service_id?.name !== null &&
    enquiryData?.sub_service_id?.name !== undefined;

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Available</Box>
      </StyledGridOverlay>
    );
  }
  const rows = [];

  const columns = [
    //     {
    //       field: "active",
    //       headerName: "Active",
    //       flex: 0.4,
    //  sortable:false,
    //  disableColumnMenu :true,
    //       renderCell: (params) => (
    //         <div>
    //           {params.row?.is_curr_assignee && (
    //            <ApproveIcon/>
    //           )}

    //         </div>
    //       ),
    //       headerAlign: "center",
    //       align: "center",
    //     },

    {
      field: "assing_to",
      headerName: "Assigned To",
      flex: 1,
      valueGetter: (params) =>
        `${params.row?.assign_to?.first_name || ""} ${
          params.row?.assign_to?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {params.row?.assign_to?.first_name}{" "}
          {params.row?.assign_to?.last_name
            ? params.row?.assign_to?.last_name
            : ""}
          {params.row?.is_curr_assignee && (
            <Chip
              label="Active"
              size="normal"
              variant="contained"
              color="secondary"
              marginLeft="10px"
            />
          )}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "assing_by",
      headerName: "Assigned By",
      flex: 1,

      renderCell: (params) => (
        <div>
          {params.row?.assigned_by?.first_name}{" "}
          {params.row?.assigned_by?.last_name}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "assing_time",
      headerName: "Assigned Time",
      flex: 1,

      renderCell: (params) => (
        <div>
          {params.row?.assigned_date} {params.row?.assgined_time}
        </div>
      ),
      headerAlign: "center",
      align: "center",
    },
    {
      field: "assing_type",
      headerName: "Assign Type",
      flex: 1,

      renderCell: (params) => <div>{params.row?.assign_type}</div>,
      headerAlign: "center",
      align: "center",
    },
  ];

  const StyledPopper = (props) => (
    <Popper
      {...props}
      style={{
        zIndex: 1300, // Ensure the dropdown appears above other elements
        width: "auto",
        maxWidth: "100%",
        marginTop: 0, // Ensure the dropdown starts right below the CustomTextFieldComp
      }}
      placement="bottom-start" // Ensure dropdown appears below the CustomTextFieldComp
      modifiers={[
        {
          name: "flip",
          enabled: true,
          options: {
            fallbackPlacements: ["bottom"],
          },
        },
        {
          name: "preventOverflow",
          options: {
            boundary: "viewport",
            padding: 8, // Ensure the dropdown stays within the viewport
          },
        },
      ]}
    />
  );
  // Add service Popup
  const handleOpenAddService = () => {
    setAddservicePopup(true);
  };
  const handleCloseAddService = () => {
    setAddservicePopup(false);
  };

  const handleShowMobile = () => {
    if (studentInfo?.mobile) {
      handleFetchMobileNumber(() => setShowMobile(true));
    }
  };

  const handleHideMobile = () => {
    setShowMobile(false);
  };

  const handleShowSecondaryMobile = () => {
    if (studentInfo?.secondary_mobile) {
      handleFetchMobileNumber(() => setShowSecondaryMobile(true));
    }
  };

  const handleHideSecondaryMobile = () => {
    setShowSecondaryMobile(false);
  };

  const handleShowWhatsAppMobile = () => {
    if (studentInfo?.whatsapp_number) {
      handleFetchMobileNumber(() => setShowWhatAppNumber(true));
    }
  };

  const handleHideWhatsAppMobile = () => {
    setShowWhatAppNumber(false);
  };

  const handleFetchMobileNumber = async (onSuccessCallback) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };

    const requestData = {
      user_id: parseInt(userId),
      enquiry_id: enquiryId,
    };

    try {
      setMobileLoading(true);
      const response = await fetch(`${API_ENDPOINT}show-enq-mobile`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });
      const result = await response.json();
      if (response.ok) {
        setMobileLoading(false);
        if (typeof onSuccessCallback === "function") {
          onSuccessCallback();
        }
      } else {
        showSnackbar(result.message, "error");
        setMobileLoading(false);
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
      setMobileLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          ` ${API_ENDPOINT}route/getallactiveandinactiveuser`,
        );
        if (response.ok) {
          const data = await response.json();
          setAllUserList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="content">
      <Backdrop open={recycleRequestLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Processing Recycle Request...
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>

      <Backdrop open={mobileLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Processing Mobile Number Request...
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        m={2}
        display="flex"
        flexDirection={{ sm: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ sm: "flex-start", md: "center" }}
      >
        <Stack direction="row" spacing={2}>
          {isBookDemoDisabled ? (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleOpenDemoPopup}
              disabled={isRecycledReadonly}
            >
              Book Demo
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleOpenRescheduleDemoPopup}
              disabled={isRescheduleDemoDisabled || isRecycledReadonly}
            >
              Reschedule Demo
            </Button>
          )}

          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => handleEnrollStudent()}
            disabled={isEnrollStudentDisabled || isRecycledReadonly}
          >
            Enroll Student
          </Button>

          {studentInfo?.service_id?.id == 1 && (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={() => handleViewClassDetails()}
              disabled={!isEnrollStudentDisabled}
            >
              View Class Details
            </Button>
          )}

          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleOpenAddService}
            // disabled={isRecycledReadonly}
          >
            Add More Service
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handleOpenAddFeePopup}
            disabled={isRecycledReadonly || parseInt(employeeCountry) != 101}
          >
            Add Miscellaneous Fees
          </Button>
        </Stack>

        <Stack direction="row" spacing={2} ml="auto">
          {studentInfo?.service_id?.id == 2 ? (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleProgramHistoryClick}
            >
              Program History
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleClassHistoryClick}
            >
              Class History
            </Button>
          )}

          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handlePaymentHistoryClick}
          >
            Payment History
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={handlesubServiceHistoryClick}
          >
            View Subservice History
          </Button>
        </Stack>
      </Box>

      {showPayment && (
        <Box mb={2}>
          <Item>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <EnquiryPayments
                enquiryId={enquiryId}
                payments={payments}
                loading={paymentLoading}
                isRecycledReadonly={isRecycledReadonly}
                miscellaneousPaymentLoading={miscellaneousPaymentLoading}
                miscellaneousPayment={miscellaneousPayment}
                selectedSubService={selectedSubService}
              />
            </div>
          </Item>
        </Box>
      )}

      {showClasses && (
        <Box mb={2}>
          <Item>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <ViewClassHistory
                enquiryId={enquiryId}
                classes={classes}
                loading={classLoading}
                setClasses={setClasses}
                isRecycledReadonly={isRecycledReadonly}
              />
            </div>
          </Item>
        </Box>
      )}

      {showPrograms && (
        <Box mb={2}>
          <Item>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <ViewProgramHistory
                enquiryId={enquiryId}
                programs={programs}
                loading={programLoading}
                setPrograms={setPrograms}
                isRecycledReadonly={isRecycledReadonly}
              />
            </div>
          </Item>
        </Box>
      )}

      {showSuservice && (
        <Box mb={2}>
          <Item>
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <SubServiceDetails
                enquiryPersonalId={studentInfo?.enq_personal_detail_id}
              />
            </div>
          </Item>
        </Box>
      )}

      {/* Personal Info*/}
      <Grid container spacing={2}>
        <Grid item xs={12} md={9} lg={9} sm={12}>
          <Box container spacing="2" id="scrollable-container">
            <Stack direction="column" spacing={2}>
              <Item>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  mb={2}
                  id="personal-info"
                >
                  <Typography variant="h4" fontWeight={700}>
                    Personal Information
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSubmit(handleSaveStudentInfo)}
                    disabled={enquiryData.is_active === 0}
                  >
                    Save
                  </Button>
                </Box>
                <Grid container spacing={3}>
                  {/* <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">
                      First Name
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="first_name"
                      control={control}
                      //defaultValue={ enquiryData?.first_name || '' }

                      rules={nameWithRequiredPattern}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          fullWidth
                          value={studentInfo.first_name || ""}

                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              first_name: e.target.value,
                            });
                            handleFieldChange("first_name", e.target.value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          error={Boolean(errors.first_name)}
                          helperText={
                            errors.first_name && "First name is required"
                          }
                        />
                      )}
                    />
                  </Grid> */}
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">
                      First Name
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="first_name"
                      control={control}
                      rules={nameWithRequiredPattern}
                      value={studentInfo.first_name || ""}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          fullWidth
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value); // update React Hook Form's state
                            setStudentInfo({
                              ...studentInfo,
                              first_name: value,
                            });
                            handleFieldChange("first_name", value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          error={Boolean(errors.first_name)}
                          helperText={errors.first_name?.message}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>
                      Last Name
                    </Typography>
                    <Controller
                      name="last_name"
                      control={control}
                      rules={namePattern}
                      //defaultValue={ enquiryData?.last_name || '' }
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          fullWidth
                          value={studentInfo.last_name || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value); // update React Hook Form's state
                            setStudentInfo({
                              ...studentInfo,
                              last_name: e.target.value,
                            });
                            handleFieldChange("last_name", e.target.value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          error={Boolean(errors.last_name)}
                          helperText={
                            errors.last_name && errors.last_name?.message
                          }
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>Gender</Typography>
                    <Controller
                      name="gender"
                      control={control}
                      defaultValue={
                        enquiryPersonalDetails?.gender?.toLowerCase() || ""
                      }
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          onChange={(e) => {
                            field.onChange(e); // ✅ Important
                            setStudentInfo({
                              ...studentInfo,
                              gender: e.target.value,
                            });
                            handleFieldChange("gender", e.target.value);
                          }}
                          error={Boolean(errors.gender)}
                          helperText={errors.gender && "Gender is required"}
                        >
                          <MenuItem value="male">Male</MenuItem>
                          <MenuItem value="female">Female</MenuItem>
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>
                      Date of Birth
                    </Typography>
                    <Controller
                      name="dob"
                      control={control}
                      defaultValue={enquiryPersonalDetails?.dob || ""}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          fullWidth
                          onChange={(e) => {
                            field.onChange(e); // ✅ update RHF
                            setStudentInfo({
                              ...studentInfo,
                              dob: e.target.value,
                            });
                            handleFieldChange("dob", e.target.value);
                          }}
                          type="date"
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                            inputProps: { max: "2005-12-31" },
                          }}
                          error={Boolean(errors.dob)}
                          helperText={errors.dob && "Date of Birth is required"}
                        />
                      )}
                    />
                    {errors.dob && (
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          top: 0,
                          right: -8,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>
                      Marital Status
                    </Typography>
                    <Controller
                      name="marital_status"
                      control={control}
                      defaultValue={
                        enquiryPersonalDetails?.marital_status || ""
                      }
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          onChange={(e) => {
                            field.onChange(e); // ✅ important

                            setStudentInfo({
                              ...studentInfo,
                              marital_status: e.target.value,
                            });

                            handleFieldChange("marital_status", e.target.value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={!!errors.marital_status}
                          //helperText={errors.gender && 'Gender is required'}
                        >
                          {maritalStatus.map((maritalstatus) => (
                            <MenuItem
                              key={maritalstatus.id}
                              value={maritalstatus.id}
                            >
                              {maritalstatus.maritial_type}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>
                </Grid>
              </Item>

              <Item>
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography id="contact-info" variant="h4" fontWeight={700}>
                    Contact Information
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSubmit(handleSaveStudentInfo)}
                    disabled={isRecycledReadonly}
                  >
                    Save
                  </Button>
                </Box>
                <Grid container spacing={3}>
                  <Grid item xs={6} md={4} lg={4} container>
                    <Grid item xs={4} md={4} lg={5}>
                      <Typography variant="h6">
                        ISD Code
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="mobile_country_code"
                        control={control}
                        //defaultValue={91}
                        //rules={{ required: "Country code is required" }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            value={studentInfo.mobile_country_code}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state

                              setStudentInfo({
                                ...studentInfo,
                                mobile_country_code: e.target.value,
                              });
                              handleFieldChange(
                                "mobile_country_code",
                                e.target.value,
                              );
                              clearErrors("mobile");
                            }}
                            error={Boolean(errors.mobile_country_code)}
                            //helperText={errors.country && 'Country is required'}
                            renderValue={(selected) => selected?.phone_code}
                          >
                            {countries.map((country) => (
                              <MenuItem
                                key={country.phone_code}
                                value={country.phone_code}
                              >
                                {country.phone_code}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                      {errors.mobile_country_code && (
                        <span style={{ color: "red" }}>
                          {errors.mobile_country_code.message}
                        </span>
                      )}
                    </Grid>

                    <Grid item xs={8} md={8} lg={7}>
                      <Typography variant="h6">
                        Mobile
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="mobile"
                        control={control}
                        //defaultValue='+91'
                        rules={{
                          required: "Contact number is required",
                          validate: (value) => {
                            const isdCode = watch("mobile_country_code");
                            const error = validateMobile(isdCode, value);
                            return error || true;
                          },
                        }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            {...field}
                            size="normal"
                            value={studentInfo.mobile}
                            type={
                              ["advisor", "trainer"].includes(userRole)
                                ? showMobile
                                  ? "number"
                                  : "password"
                                : "number"
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state

                              setStudentInfo({
                                ...studentInfo,
                                mobile: e.target.value,
                              });
                              handleFieldChange("mobile", e.target.value);
                              // Validate mobile number if ISD code is 91
                              if (studentInfo.mobile_country_code === "91") {
                                const isValidMobile = /^[1-9][0-9]{9}$/.test(
                                  studentInfo.mobile,
                                );
                                if (!isValidMobile) {
                                  setError("mobile", {
                                    type: "manual",
                                    message:
                                      "Invalid mobile number. It should be a 10-digit number starting with a non-zero digit.",
                                  });
                                } else {
                                  clearErrors("mobile");
                                }
                              } else {
                                clearErrors("mobile"); // Remove any mobile errors for other ISD codes
                              }
                            }}
                            InputProps={{
                              endAdornment:
                                ["advisor", "trainer"].includes(userRole) &&
                                studentInfo?.mobile ? (
                                  <InputAdornment position="end">
                                    {showMobile ? (
                                      <RemoveRedEyeOutlinedIcon
                                        fontSize="small"
                                        onClick={handleHideMobile}
                                        sx={{
                                          cursor: "pointer",
                                          fontSize: "1rem",
                                          "&:hover": {
                                            color: "rgb(33, 150, 243)",
                                          },
                                        }}
                                      />
                                    ) : (
                                      <VisibilityOffOutlinedIcon
                                        fontSize="small"
                                        onClick={handleShowMobile}
                                        sx={{
                                          cursor: "pointer",
                                          fontSize: "1rem",
                                          "&:hover": {
                                            color: "rgb(33, 150, 243)",
                                          },
                                        }}
                                      />
                                    )}
                                  </InputAdornment>
                                ) : null,

                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            error={!!errors.mobile}
                            //helperText={errors.mobile?.message}
                            fullWidth
                          />
                        )}
                      ></Controller>
                      {errors.mobile && (
                        <span style={{ color: "red" }}>
                          {errors.mobile.message}
                        </span>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={6} md={4} lg={4} container>
                    <Grid item xs={4} md={4} lg={5}>
                      <Typography variant="h6">
                        ISD Code
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="whatsapp_country_code"
                        control={control}
                        //defaultValue={91}
                        //rules={{ required: "Country code is required" }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={studentInfo.whatsapp_country_code}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state

                              setStudentInfo({
                                ...studentInfo,
                                whatsapp_country_code: e.target.value,
                              });
                              handleFieldChange(
                                "whatsapp_country_code",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            // defaultValue={91}
                            error={Boolean(errors.whatsapp_country_code)}
                          >
                            {countries.map((country) => (
                              <MenuItem
                                key={country.phone_code}
                                value={country.phone_code}
                              >
                                {country.phone_code}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                      {errors.whatsapp_country_code && (
                        <span style={{ color: "red" }}>
                          {errors.whatsapp_country_code.message}
                        </span>
                      )}
                    </Grid>
                    <Grid item xs={8} md={8} lg={7}>
                      <Typography variant="h6">
                        Whatsapp Number
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="whatsapp_number"
                        control={control}
                        rules={{
                          validate: (value) => {
                            const isdCode = watch("whatsapp_country_code");
                            const error = validateMobile(isdCode, value);
                            return error || true;
                          },
                        }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            {...field}
                            type={
                              ["advisor", "trainer"].includes(userRole)
                                ? showWhatsAppNumber
                                  ? "number"
                                  : "password"
                                : "number"
                            }
                            value={studentInfo.whatsapp_number}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state

                              setStudentInfo({
                                ...studentInfo,
                                whatsapp_number: e.target.value,
                              });
                              handleFieldChange(
                                "whatsapp_number",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              endAdornment:
                                ["advisor", "trainer"].includes(userRole) &&
                                studentInfo?.whatsapp_number ? (
                                  <InputAdornment position="end">
                                    {showWhatsAppNumber ? (
                                      <RemoveRedEyeOutlinedIcon
                                        fontSize="small"
                                        onClick={handleHideWhatsAppMobile}
                                        sx={{
                                          cursor: "pointer",
                                          fontSize: "1rem",
                                          "&:hover": {
                                            color: "blue",
                                          },
                                        }}
                                      />
                                    ) : (
                                      <VisibilityOffOutlinedIcon
                                        fontSize="small"
                                        onClick={handleShowWhatsAppMobile}
                                        sx={{
                                          cursor: "pointer",
                                          fontSize: "1rem",
                                          "&:hover": {
                                            color: "rgb(33, 150, 243)",
                                          },
                                        }}
                                      />
                                    )}
                                  </InputAdornment>
                                ) : null,

                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            error={!!errors.whatsapp_number}
                            // helperText={errors.whatsapp_number?.message}
                            fullWidth
                          />
                        )}
                      ></Controller>
                      {errors.whatsapp_number && (
                        <span style={{ color: "red" }}>
                          {errors.whatsapp_number.message}
                        </span>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={6} md={4} lg={4} container>
                    <Grid item xs={4} md={4} lg={5}>
                      <Typography variant="h6">ISD Code</Typography>
                      <Controller
                        name="secondary_mobile_country_code"
                        control={control}
                        defaultValue={91}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={studentInfo.secondary_mobile_country_code}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state
                              setStudentInfo({
                                ...studentInfo,
                                secondary_mobile_country_code: e.target.value,
                              });
                              handleFieldChange(
                                "secondary_mobile_country_code",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            error={Boolean(
                              errors.secondary_mobile_country_code,
                            )}
                          >
                            {countries.map((country) => (
                              <MenuItem
                                key={country.phone_code}
                                value={country.phone_code}
                              >
                                {country.phone_code}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                      {errors.secondary_mobile_country_code && (
                        <span style={{ color: "red" }}>
                          {errors.secondary_mobile_country_code.message}
                        </span>
                      )}
                    </Grid>

                    <Grid item xs={8} md={8} lg={7}>
                      <Typography variant="h6">Secondary Mobile</Typography>
                      <Controller
                        name="secondary_mobile"
                        control={control}
                        rules={{
                          validate: (value) => {
                            const isdCode = watch(
                              "secondary_mobile_country_code",
                            );
                            const error = validateMobile(isdCode, value);
                            return error || true;
                          },
                        }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            {...field}
                            type={
                              ["advisor", "trainer"].includes(userRole)
                                ? showSecondaryMobile
                                  ? "number"
                                  : "password"
                                : "number"
                            }
                            value={studentInfo.secondary_mobile}
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state
                              setStudentInfo({
                                ...studentInfo,
                                secondary_mobile: e.target.value,
                              });
                              handleFieldChange(
                                "secondary_mobile",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              endAdornment:
                                ["advisor", "trainer"].includes(userRole) &&
                                studentInfo?.secondary_mobile ? (
                                  <InputAdornment position="end">
                                    {showSecondaryMobile ? (
                                      <RemoveRedEyeOutlinedIcon
                                        fontSize="small"
                                        onClick={handleHideSecondaryMobile}
                                        sx={{
                                          cursor: "pointer",
                                          fontSize: "1rem",
                                          "&:hover": {
                                            color: "rgb(33, 150, 243)",
                                          },
                                        }}
                                      />
                                    ) : (
                                      <VisibilityOffOutlinedIcon
                                        fontSize="small"
                                        onClick={handleShowSecondaryMobile}
                                        sx={{
                                          cursor: "pointer",
                                          fontSize: "1rem",
                                          "&:hover": {
                                            color: "rgb(33, 150, 243)",
                                          },
                                        }}
                                      />
                                    )}
                                  </InputAdornment>
                                ) : null,

                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            error={!!errors.secondary_mobile}
                            fullWidth
                          />
                        )}
                      ></Controller>
                      {errors.secondary_mobile && (
                        <span style={{ color: "red" }}>
                          {errors.secondary_mobile.message}
                        </span>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={6} md={4} lg={4} container>
                    <Grid item xs={4} md={4} lg={5}>
                      <Typography variant="h6">ISD Code</Typography>

                      <Controller
                        name="guardian_mobile_country_code"
                        control={control}
                        defaultValue={91}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={studentInfo.guardian_mobile_country_code}
                            onChange={(e) => {
                              const value = e.target.value;

                              field.onChange(value);

                              setStudentInfo({
                                ...studentInfo,
                                guardian_mobile_country_code: value,
                              });

                              handleFieldChange(
                                "guardian_mobile_country_code",
                                value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            error={Boolean(errors.guardian_mobile_country_code)}
                          >
                            {countries.map((country) => (
                              <MenuItem
                                key={country.phone_code}
                                value={country.phone_code}
                              >
                                {country.phone_code}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />

                      {errors.guardian_mobile_country_code && (
                        <span style={{ color: "red" }}>
                          {errors.guardian_mobile_country_code.message}
                        </span>
                      )}
                    </Grid>

                  <Grid item xs={8} md={8} lg={7}>
  <Typography variant="h6">Guardian Mobile</Typography>

  <Controller
    name="guardian_mobile"
    control={control}
    rules={{
      validate: (value) => {
        const isdCode = watch("guardian_mobile_country_code");

        const error = validateMobile(isdCode, value);

        return error || true;
      },
    }}
    render={({ field }) => (
      <CustomTextFieldComp
        size="normal"
        {...field}
        type="number"
        value={studentInfo.guardian_mobile || ""}
        onChange={(e) => {
          const value = e.target.value;

          field.onChange(value);

          setStudentInfo({
            ...studentInfo,
            guardian_mobile: value,
          });

          handleFieldChange("guardian_mobile", value);
        }}
        InputProps={{
          style: { borderRadius: "10px" },
          readOnly: isRecycledReadonly,
        }}
        error={!!errors.guardian_mobile}
        fullWidth
      />
    )}
  />

  {errors.guardian_mobile && (
    <span style={{ color: "red" }}>
      {errors.guardian_mobile.message}
    </span>
  )}
</Grid>
                  </Grid>

                  <Grid item xs={6} md={4} lg={4}>
                    <Typography variant="h6">
                      Email
                      {/* <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span> */}
                    </Typography>
                    <Controller
                      name="email"
                      control={control}
                      rules={emailPattern}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          value={studentInfo.email}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value); // update React Hook Form's state  const value = e.target.value;

                            setStudentInfo({
                              ...studentInfo,
                              email: e.target.value,
                            });
                            handleFieldChange("email", e.target.value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          variant="outlined"
                          error={!!errors.email}
                          fullWidth
                        />
                      )}
                    ></Controller>
                    {errors.email && (
                      <span style={{ color: "red" }}>
                        {errors.email.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={4}>
                    <Typography variant="h6">Secondary Email</Typography>
                    <Controller
                      name="secondary_email"
                      control={control}
                      rules={emailPattern}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          value={studentInfo.secondary_email}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            setStudentInfo({
                              ...studentInfo,
                              secondary_email: e.target.value,
                            });
                            handleFieldChange(
                              "secondary_email",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          variant="outlined"
                          error={!!errors.secondary_email}
                          fullWidth
                        />
                      )}
                    ></Controller>
                    {errors.secondary_email && (
                      <span style={{ color: "red" }}>
                        {errors.secondary_email.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={4}>
                    <Typography variant="h6">
                      Country of Residence
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="country_id"
                      control={control}
                      defaultValue={101}
                      rules={{ required: "Country is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          // defaultValue={101}
                          error={Boolean(errors.country_id)}
                          //helperText={errors.country && 'Country is required'}
                        >
                          {countryList.map((country) => (
                            <MenuItem key={country.id} value={country.id}>
                              {country.country_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.country_id && (
                      <span style={{ color: "red" }}>
                        {errors.country_id.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>Pincode</Typography>
                    <Controller
                      name="pincode_id"
                      control={control}
                      //rules={{ required: "Pin code is required", pattern: { value: /^\d{6}$/, message: "Invalid pin code" } }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.pincode_id)}
                          // onChange={handlePinCodeChange}
                          value={studentInfo.pincode_id || null}
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              pincode_id: e.target.value,
                            });
                            handlePinCodeChange2(e);
                          }}
                        />
                      )}
                    />
                    {errors.pincode_id && (
                      <span className="error-message" style={{ color: "red" }}>
                        {errors.pincode_id.message}
                      </span>
                    )}
                    {pincodeError && (
                      <span className="error-message" style={{ color: "red" }}>
                        {pincodeError}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>State</Typography>
                    <Controller
                      name="state_id"
                      control={control}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          value={selectedState}
                          onChange={handleStateChange}
                          // defaultValue={pinCodeData?.state}
                          error={Boolean(errors.state_id)}
                          //helperText={errors.state}
                        >
                          {states.map((state) => (
                            <MenuItem key={state.id} value={state.id}>
                              {state.state_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>City</Typography>
                    <Controller
                      name="city_id"
                      control={control}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          value={selectedCity}
                          onChange={handleCityChange}
                          //defaultValue="IN"
                          error={Boolean(errors.city_id)}
                          // helperText={errors.city }
                        >
                          {cities.map((city) => (
                            <MenuItem key={city.id} value={city.id}>
                              {city.city_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>
                      Nearest Branch{" "}
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="nearest_branch_id"
                      control={control}
                      rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={nearest_branch}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.nearest_branch_id)}
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value); // update React Hook Form's state
                            setNearestBranch(e.target.value);
                            setStudentInfo({
                              ...studentInfo,
                              nearest_branch_id: e.target.value,
                            });
                            handleFieldChange(
                              "nearest_branch_id",
                              e.target.value,
                            );
                          }}
                          //onChange={(event) => setNearestBranch(event.target.value)}
                          // helperText={errors.nearest_branch && 'Branch Name is required'}
                        >
                          {branches.map((branch) => (
                            <MenuItem key={branch.id} value={branch.id}>
                              {branch.branch_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.nearest_branch_id && (
                      <span style={{ color: "red" }}>
                        {errors.nearest_branch_id.message}
                      </span>
                    )}
                  </Grid>
                </Grid>
              </Item>

              {/* Mandatory Information */}

              <Item>
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography id="mandatory_info" variant="h4" fontWeight={700}>
                    Mandatory Information
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSubmit(handleSaveStudentInfo)}
                    disabled={isRecycledReadonly}
                  >
                    Save
                  </Button>
                </Box>
                <Grid container spacing={3}>
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">
                      Service Name
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="service_id"
                      control={control}
                      rules={{ required: "Service name is required" }}
                      defaultValue="test preparation"
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly || isServiceReadOnly,
                            // disabled: true
                          }}
                          fullWidth
                          value={selectedService}
                          onChange={handleServiceChange}
                          // defaultValue='test prep'
                          error={Boolean(errors.service_id)}
                          //helperText={errors.service_name}
                        >
                          {services.map((service) => (
                            <MenuItem key={service.id} value={service.id}>
                              {service.service_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.service_id && (
                      <span style={{ color: "red" }}>
                        {errors.service_id.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">
                      Sub Service
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="sub_service_id"
                      control={control}
                      rules={{ required: "Sub Service is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={selectedSubService}
                          onChange={handleSubServiceChange}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly:
                              isRecycledReadonly || issubServiceReadOnly,
                          }}
                          fullWidth
                          // defaultValue='test prep'
                          error={Boolean(errors.sub_service_id)}
                          //helperText={errors.service_name}
                        >
                          {subServices.map((service) => (
                            <MenuItem key={service.id} value={service.id}>
                              {service.name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.service_name && (
                      <span style={{ color: "red" }}>
                        {errors.service_name.message}
                      </span>
                    )}
                  </Grid>

                  {(selectedSubService === 13 || selectedSubService === 14) && (
                    <Grid item xs={6} md={4} lg={3}>
                      <Typography variant="h6">
                        Scholars Admission Program
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="premium_admission_programs_id"
                        control={control}
                        rules={{
                          required:
                            selectedSubService === 13 ||
                            selectedSubService === 14
                              ? "Field is required"
                              : false,
                        }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={
                              studentInfo.premium_admission_programs_id?.id ||
                              studentInfo.premium_admission_programs_id ||
                              null
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state
                              setStudentInfo({
                                ...studentInfo,
                                premium_admission_programs_id: e.target.value,
                              });
                              handleFieldChange(
                                "premium_admission_programs_id",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            // defaultValue='test prep'
                            error={Boolean(
                              errors.premium_admission_programs_id,
                            )}
                            //helperText={errors.service_name}
                          >
                            {subServicesPrograms.map((service) => (
                              <MenuItem key={service.id} value={service.id}>
                                {service.name}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                      {errors.premium_admission_programs_id && (
                        <span style={{ color: "red" }}>
                          {errors.premium_admission_programs_id.message}
                        </span>
                      )}
                    </Grid>
                  )}

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Purpose Of Test</Typography>
                    <Controller
                      name="purpose_of_test_id"
                      control={control}
                      //rules={{ required: "Purpose of Test is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={
                            studentInfo.purpose_of_test_id?.id ||
                            studentInfo.purpose_of_test_id ||
                            null
                          }
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              purpose_of_test_id: e.target.value,
                            });
                            handleFieldChange(
                              "purpose_of_test_id",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          // defaultValue='test prep'
                          error={Boolean(errors.purpose_of_test_id)}
                          //helperText={errors.service_name}
                        >
                          {purposeOfTest.map((purpose) => (
                            <MenuItem key={purpose.id} value={purpose.id}>
                              {purpose.purpose_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.purpose_of_test_id && (
                      <span style={{ color: "red" }}>
                        {errors.purpose_of_test_id.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Lead Class Experience</Typography>
                    <Controller
                      name="lead_test_experience_id"
                      control={control}
                      //rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={studentInfo.lead_test_experience_id || null}
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              lead_test_experience_id: e.target.value,
                            });
                            handleFieldChange(
                              "lead_test_experience_id",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.lead_class_experience_id)}
                          //helperText={errors.exam_status}
                          // onChange={(e) => handleExamStatusChange(e.target.value)}
                        >
                          {leadTestExperience.map((experience) => (
                            <MenuItem key={experience.id} value={experience.id}>
                              {experience.test_experience}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.lead_class_experience_id && (
                      <span style={{ color: "red" }}>
                        {errors.lead_class_experience_id.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Exam Type Class</Typography>
                    <Controller
                      name="test_type_id"
                      control={control}
                      // rules={{ required: "Exam Type is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={
                            studentInfo.test_type_id?.id ||
                            studentInfo.test_type_id ||
                            null
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            field.onChange(value); // update React Hook Form's state
                            setStudentInfo({
                              ...studentInfo,
                              test_type_id: e.target.value,
                            });
                            handleFieldChange("test_type_id", e.target.value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.test_type_id)}
                          //helperText={errors.test_type}
                        >
                          {testtypes.map((testtype) => (
                            <MenuItem key={testtype.id} value={testtype.id}>
                              {testtype.name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.test_type_id && (
                      <span style={{ color: "red" }}>
                        {errors.test_type_id.message}
                      </span>
                    )}
                  </Grid>

                  {/* Ielts Specification */}
                  {selectedTestTypeId?.name === "IELTS" && (
                    <>
                      <Grid item xs={6} md={4} lg={3}>
                        <Typography variant="h6">
                          Sub Test Type
                          <span
                            style={{
                              color: "red",
                              position: "absolute",
                              marginLeft: "4px",
                              fontSize: "1em",
                            }}
                          >
                            *
                          </span>
                        </Typography>
                        <Controller
                          name="sub_test_type_id"
                          control={control}
                          rules={{ required: "Sub Exam Type is required" }}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              value={
                                studentInfo.sub_test_type_id?.id ||
                                studentInfo.sub_test_type_id ||
                                null
                              }
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  sub_test_type_id: e.target.value,
                                });
                                handleFieldChange(
                                  "sub_test_type_id",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                              }}
                              fullWidth
                              error={Boolean(errors.sub_test_type_id)}
                              //helperText={errors.test_type}
                            >
                              {subTestType.map((testtype) => (
                                <MenuItem key={testtype.id} value={testtype.id}>
                                  {testtype.name}
                                </MenuItem>
                              ))}
                            </CustomTextFieldComp>
                          )}
                        />
                        {errors.sub_test_type_id && (
                          <span style={{ color: "red" }}>
                            {errors.sub_test_type_id.message}
                          </span>
                        )}
                      </Grid>

                      <Grid item xs={6} md={4} lg={3}>
                        <Typography variant="h6">
                          Test Delivery Format
                        </Typography>
                        <Controller
                          name="test_delivery_format_id"
                          control={control}
                          // rules={{
                          //   required: "Test Delivery Format is required",
                          // }}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              value={
                                studentInfo.test_delivery_format_id?.id ||
                                studentInfo.test_delivery_format_id ||
                                null
                              }
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  test_delivery_format_id: e.target.value,
                                });
                                handleFieldChange(
                                  "test_delivery_format_id",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                              }}
                              fullWidth
                              error={Boolean(errors.test_delivery_format_id)}
                              //helperText={errors.test_type}
                            >
                              {subTestTypeFormat.map((testtype) => (
                                <MenuItem key={testtype.id} value={testtype.id}>
                                  {testtype.name}
                                </MenuItem>
                              ))}
                            </CustomTextFieldComp>
                          )}
                        />
                        {errors.test_delivery_format_id && (
                          <span style={{ color: "red" }}>
                            {errors.test_delivery_format_id.message}
                          </span>
                        )}
                      </Grid>
                    </>
                  )}

                  {selectedTestTypeId?.name === "PTE" && (
                    <Grid item xs={6} md={4} lg={3}>
                      <Typography variant="h6">Sub Test Type</Typography>
                      <Controller
                        name="sub_test_type_id"
                        control={control}
                        // rules={{ required: "Sub Exam Type is required" }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={
                              studentInfo.sub_test_type_id?.id ||
                              studentInfo.sub_test_type_id ||
                              null
                            }
                            onChange={(e) => {
                              setStudentInfo({
                                ...studentInfo,
                                sub_test_type_id: e.target.value,
                              });
                              handleFieldChange(
                                "sub_test_type_id",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            error={Boolean(errors.sub_test_type_id)}
                            //helperText={errors.test_type}
                          >
                            {subTestType.map((testtype) => (
                              <MenuItem key={testtype.id} value={testtype.id}>
                                {testtype.name}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                      {errors.sub_test_type_id && (
                        <span style={{ color: "red" }}>
                          {errors.sub_test_type_id.message}
                        </span>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">
                      Preferred Delivery Mode
                    </Typography>
                    <Controller
                      name="preferred_delivery_mode"
                      control={control}
                      // rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={studentInfo.preferred_delivery_mode || null}
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              preferred_delivery_mode: e.target.value,
                            });
                            handleFieldChange(
                              "preferred_delivery_mode",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.preferred_delivery_mode)}
                          //helperText={errors.exam_status}
                          // onChange={(e) => handleExamStatusChange(e.target.value)}
                        >
                          <MenuItem value="online">Online</MenuItem>
                          <MenuItem value="offline">Offline</MenuItem>
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.preferred_delivery_mode && (
                      <span style={{ color: "red" }}>
                        {errors.preferred_delivery_mode.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }} variant="h6">
                      First Country of Interest
                    </Typography>
                    <Controller
                      name="target_country_id"
                      control={control}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={studentInfo.target_country_id || null}
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              target_country_id: e.target.value,
                            });
                            handleFieldChange(
                              "target_country_id",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.target_country)}
                          //helperText={errors.target_country}
                        >
                          {targetCountries.map((country) => (
                            <MenuItem key={country.id} value={country.id}>
                              {country.country_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6" style={{ color: "black" }}>
                      Lead Source Type{" "}
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="lead_source_type_id"
                      control={control}
                      rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly:
                              enquiryData.lead_source_type_id === null ||
                              enquiryData.lead_source_type_id?.id === null
                                ? false
                                : true,
                          }}
                          fullWidth
                          value={selectedSourceType}
                          onChange={handleSourceTypeChange}
                          error={Boolean(errors.lead_source_type_id)}
                          helperText={errors.lead_source_type_id?.message}
                        >
                          {leadSources.map((type) => (
                            <MenuItem key={type.id} value={type.id}>
                              {type.name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  {selectedSourceType !== null && (
                    <Grid item xs={6} md={4} lg={3}>
                      <Typography variant="h6" style={{ color: "black" }}>
                        Sub Lead Source Type{" "}
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="sub_lead_source_type_id"
                        control={control}
                        rules={{ required: "Field is required" }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={
                              studentInfo.sub_lead_source_type_id?.id ||
                              studentInfo.sub_lead_source_type_id ||
                              null
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              field.onChange(value); // update React Hook Form's state
                              setStudentInfo({
                                ...studentInfo,
                                sub_lead_source_type_id: e.target.value,
                              });
                              handleFieldChange(
                                "sub_lead_source_type_id",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly:
                                studentInfo.sub_lead_source_type_id?.id ===
                                  null ||
                                studentInfo.sub_lead_source_type_id === null
                                  ? false
                                  : true,
                            }}
                            fullWidth
                            error={Boolean(errors.sub_lead_source_type_id)}
                            helperText={errors.sub_lead_source_type_id?.message}
                          >
                            {subLeadSources.map((subSource) => (
                              <MenuItem key={subSource.id} value={subSource.id}>
                                {subSource.source_type}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                    </Grid>
                  )}

                  {/* Reference By Marketing */}

                  {(studentInfo.sub_lead_source_type_id?.id === 53 ||
                    studentInfo.sub_lead_source_type_id === 53) &&
                    (studentInfo.reference_marketing_id?.id ||
                      studentInfo.reference_marketing_id) && (
                      <Grid item xs={6} md={4} lg={3}>
                        <Typography variant="h6">
                          Reference By Marketing
                        </Typography>
                        <Controller
                          name="reference_walkin_id"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              value={
                                studentInfo.reference_marketing_id?.id ||
                                studentInfo.reference_marketing_id ||
                                null
                              }
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  reference_marketing_id: e.target.value,
                                });
                                handleFieldChange(
                                  "reference_marketing_id",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: true,
                              }}
                              fullWidth
                              error={Boolean(errors.reference_marketing_id)}
                            >
                              {referenceByList.map((reference) => (
                                <MenuItem
                                  key={reference.id}
                                  value={reference.id}
                                >
                                  {reference.name}
                                </MenuItem>
                              ))}
                            </CustomTextFieldComp>
                          )}
                        />
                      </Grid>
                    )}

                  {/* Reference By Employee */}

                  {(studentInfo.sub_lead_source_type_id?.id === 53 ||
                    studentInfo.sub_lead_source_type_id === 53) &&
                    (studentInfo.reference_employee_id?.id ||
                      studentInfo.reference_employee_id) && (
                      <Grid item xs={6} md={4} lg={3}>
                        <Typography variant="h6">
                          Reference By Employee
                        </Typography>
                        <Controller
                          name="reference_employee_id"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              value={
                                studentInfo.reference_employee_id?.id ||
                                studentInfo.reference_employee_id ||
                                null
                              }
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  reference_employee_id: e.target.value,
                                });
                                handleFieldChange(
                                  "reference_employee_id",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: true,
                              }}
                              fullWidth
                              error={Boolean(errors.reference_employee_id)}
                            >
                              {alluserlist.map((user) => (
                                <MenuItem key={user.id} value={user.id}>
                                  {user.first_name} {user.last_name}
                                </MenuItem>
                              ))}
                            </CustomTextFieldComp>
                          )}
                        />
                      </Grid>
                    )}

                  <Grid item xs={12} lg={9}>
                    <Typography
                      style={{ color: "black", visibility: "hidden" }}
                    >
                      Reference By
                    </Typography>
                    <Grid container gap={1}>
                      <Button
                        variant="contained"
                        size="small"
                        style={{ borderRadius: "25px" }}
                        onClick={() => handleGrandlynkPopupOpen()}
                        disabled={isRecycledReadonly}
                      >
                        Add Gradlynk Service{" "}
                      </Button>

                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        style={{ borderRadius: "25px" }}
                        onClick={handleGradlynkServiceClick}
                      >
                        Show Gradlynk Services{" "}
                      </Button>

                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        style={{ borderRadius: "25px" }}
                        onClick={handleGrandLynkStagesClick}
                      >
                       show Gradlynk Services {" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Item>

              {showGradlynkService && (
                <Box mb={2}>
                  <Item>
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <GradlynkServicesTable enquiryId={enquiryId} />
                    </div>
                  </Item>
                </Box>
              )}

              {showGradlynkStages && (
                <Box mb={2}>
                  <Item>
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <GradlynkStages enquiryData={enquiryData} />
                    </div>
                  </Item>
                </Box>
              )}

              <Item>
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography id="test-info" variant="h4" fontWeight={700}>
                    Test Details Information
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={handleSubmit(handleSaveStudentInfo)}
                    disabled={isRecycledReadonly}
                  >
                    Save
                  </Button>
                </Box>
                <Grid item xs={12} md={12} lg={12}>
                  <Box display="flex">
                    <Stack direction="row" spacing={2}>
                      <Typography variant="h6" sx={{ color: "red" }}>
                        Send English Proficiency Level Test Link to Student's
                        Email and WhatsApp?
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleSendEvaluationLink}
                        disabled={isRecycledReadonly}
                      >
                        Send
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={copyLinkToClipboard}
                        disabled={isRecycledReadonly}
                      >
                        Copy Link
                      </Button>
                    </Stack>
                  </Box>
                </Grid>
                <Grid container spacing={3} mt={0.1}>
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Exam Status</Typography>
                    <Controller
                      name="exam_status_id"
                      control={control}
                      // rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={studentInfo.exam_status_id || null}
                          onChange={(e) => {
                            handleExamStatusChange(e.target.value);
                            setStudentInfo({
                              ...studentInfo,
                              exam_status_id: e.target.value,
                            });
                            handleFieldChange("exam_status_id", e.target.value);
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.exam_status_id)}
                          //helperText={errors.exam_status}
                          // onChange={(e) => handleExamStatusChange(e.target.value)}
                        >
                          {examStatuses.map((status) => (
                            <MenuItem key={status.id} value={status.id}>
                              {status.exam_status_name}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.exam_status_id && (
                      <span style={{ color: "red" }}>
                        {errors.exam_status_id.message}
                      </span>
                    )}
                  </Grid>

                  {examStatusId === 1 && (
                    <>
                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Date of Exam
                        </Typography>
                        <Controller
                          name="tentative_test_date"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              {...field}
                              fullWidth
                              type="date"
                              value={studentInfo.tentative_test_date || null}
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  tentative_test_date: e.target.value,
                                });
                                handleFieldChange(
                                  "tentative_test_date",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                                inputProps: {
                                  min: new Date().toISOString().split("T")[0],
                                },
                              }}
                              error={Boolean(errors.date_of_exam)}
                              //helperText={errors.date_of_exam && 'Date of Exam is required'}
                            />
                          )}
                        />
                        {errors.date_of_exam && (
                          <span
                            style={{
                              color: "red",
                              position: "absolute",
                              top: 0,
                              right: -8,
                            }}
                          >
                            *
                          </span>
                        )}
                      </Grid>

                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Assumptive Proficiency Level
                        </Typography>
                        <Controller
                          name="assumptive_proficiency_level_id"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              value={
                                studentInfo.assumptive_proficiency_level_id ||
                                null
                              }
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  assumptive_proficiency_level_id:
                                    e.target.value,
                                });
                                handleFieldChange(
                                  "assumptive_proficiency_level_id",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                              }}
                              fullWidth
                              error={Boolean(errors.proficiency_level)}
                              //helperText={errors.proficiency_level}
                            >
                              {proficiencyLevel.map((status) => (
                                <MenuItem key={status.id} value={status.id}>
                                  {status.english_proficiency}
                                </MenuItem>
                              ))}
                            </CustomTextFieldComp>
                          )}
                        />
                      </Grid>

                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Target Test Score
                        </Typography>
                        <Controller
                          name="target_score"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              {...field}
                              fullWidth
                              type="number"
                              value={studentInfo.target_score || null}
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  target_score: e.target.value,
                                });
                                handleFieldChange(
                                  "target_score",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                                inputProps: {
                                  min: 1,
                                  max: 9,
                                },
                              }}
                              error={Boolean(errors.target_score)}
                              //helperText={errors.target_score }
                            />
                          )}
                        />
                        {errors.target_score && (
                          <span
                            style={{
                              color: "red",
                              position: "absolute",
                              top: 0,
                              right: -8,
                            }}
                          >
                            *
                          </span>
                        )}
                      </Grid>
                    </>
                  )}

                  {examStatusId === 2 && (
                    <>
                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Do you want to book the test?
                        </Typography>
                        <Controller
                          name="test_taken"
                          control={control}
                          // rules={{ required: "Field is required" }}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                              }}
                              fullWidth
                              error={Boolean(errors.test_taken)}
                              value={studentInfo.test_taken || null}
                              onChange={(e) => {
                                handleTestBookingStatusChange(e.target.value);
                                handleFieldChange("test_taken", e.target.value);
                              }}
                              //helperText={errors.test_booking}
                              // onChange={(e) => handleTestBookingStatusChange(e.target.value)}
                            >
                              <MenuItem value="yes">Yes</MenuItem>
                              <MenuItem value="no">No</MenuItem>
                            </CustomTextFieldComp>
                          )}
                        />
                      </Grid>

                      {testBooking === "yes" && (
                        <>
                          <Grid item xs={6} md={4} lg={3}>
                            <Typography style={{ color: "black" }}>
                              Tentative Date of Exam
                            </Typography>
                            <Controller
                              name="tentative_test_date"
                              control={control}
                              render={({ field }) => (
                                <CustomTextFieldComp
                                  size="normal"
                                  {...field}
                                  fullWidth
                                  type="date"
                                  value={
                                    studentInfo.tentative_test_date || null
                                  }
                                  onChange={(e) => {
                                    setStudentInfo({
                                      ...studentInfo,
                                      tentative_test_date: e.target.value,
                                    });
                                    handleFieldChange(
                                      "tentative_test_date",
                                      e.target.value,
                                    );
                                  }}
                                  InputProps={{
                                    style: { borderRadius: "10px" },
                                    readOnly: isRecycledReadonly,
                                    inputProps: {
                                      min: new Date()
                                        .toISOString()
                                        .split("T")[0],
                                    },
                                  }}
                                  error={Boolean(errors.test_date)}
                                  //helperText={errors.date_of_exam && 'Date of Exam is required'}
                                />
                              )}
                            />
                            {errors.date_of_exam && (
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: 0,
                                  right: -8,
                                }}
                              >
                                *
                              </span>
                            )}
                          </Grid>

                          <Grid item xs={6} md={4} lg={3}>
                            <Typography style={{ color: "black" }}>
                              Assumptive Proficiency Level
                            </Typography>
                            <Controller
                              name="assumptive_proficiency_level_id"
                              control={control}
                              render={({ field }) => (
                                <CustomTextFieldComp
                                  size="normal"
                                  select
                                  {...field}
                                  value={
                                    studentInfo.assumptive_proficiency_level_id ||
                                    null
                                  }
                                  onChange={(e) => {
                                    setStudentInfo({
                                      ...studentInfo,
                                      assumptive_proficiency_level_id:
                                        e.target.value,
                                    });
                                    handleFieldChange(
                                      "assumptive_proficiency_level_id",
                                      e.target.value,
                                    );
                                  }}
                                  InputProps={{
                                    style: { borderRadius: "10px" },
                                    readOnly: isRecycledReadonly,
                                  }}
                                  fullWidth
                                  error={Boolean(
                                    errors.english_proficiency_level,
                                  )}
                                  // helperText={errors.proficiency_level}
                                >
                                  {proficiencyLevel.map((status) => (
                                    <MenuItem key={status.id} value={status.id}>
                                      {status.english_proficiency}
                                    </MenuItem>
                                  ))}
                                </CustomTextFieldComp>
                              )}
                            />
                          </Grid>

                          <Grid item xs={6} md={4} lg={3}>
                            <Typography style={{ color: "black" }}>
                              Target Test Score
                            </Typography>
                            <Controller
                              name="target_score"
                              control={control}
                              render={({ field }) => (
                                <CustomTextFieldComp
                                  size="normal"
                                  {...field}
                                  fullWidth
                                  type="number"
                                  value={studentInfo.target_score || null}
                                  onChange={(e) => {
                                    setStudentInfo({
                                      ...studentInfo,
                                      target_score: e.target.value,
                                    });
                                    handleFieldChange(
                                      "target_score",
                                      e.target.value,
                                    );
                                  }}
                                  InputProps={{
                                    style: { borderRadius: "10px" },
                                    readOnly: isRecycledReadonly,
                                  }}
                                  error={Boolean(errors.target_score)}
                                  //helperText={errors.target_score }
                                />
                              )}
                            />
                            {errors.target_score && (
                              <span
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: 0,
                                  right: -8,
                                }}
                              >
                                *
                              </span>
                            )}
                          </Grid>
                        </>
                      )}

                      {testBooking === "no" && (
                        <Grid item xs={6} md={4} lg={3}>
                          <Typography style={{ color: "black" }}>
                            Assumptive Proficiency Level
                          </Typography>
                          <Controller
                            name="assumptive_proficiency_level_id"
                            control={control}
                            render={({ field }) => (
                              <CustomTextFieldComp
                                size="normal"
                                select
                                {...field}
                                value={
                                  studentInfo.assumptive_proficiency_level_id ||
                                  null
                                }
                                onChange={(e) => {
                                  setStudentInfo({
                                    ...studentInfo,
                                    assumptive_proficiency_level_id:
                                      e.target.value,
                                  });
                                  handleFieldChange(
                                    "assumptive_proficiency_level_id",
                                    e.target.value,
                                  );
                                }}
                                InputProps={{
                                  style: { borderRadius: "10px" },
                                  readOnly: isRecycledReadonly,
                                }}
                                fullWidth
                                error={Boolean(
                                  errors.english_proficiency_level,
                                )}
                                // helperText={errors.proficiency_level}
                              >
                                {proficiencyLevel.map((status) => (
                                  <MenuItem key={status.id} value={status.id}>
                                    {status.english_proficiency}
                                  </MenuItem>
                                ))}
                              </CustomTextFieldComp>
                            )}
                          />
                        </Grid>
                      )}
                    </>
                  )}

                  {examStatusId === 3 && (
                    <>
                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Date of Exam
                        </Typography>
                        <Controller
                          name="tentative_test_date"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              {...field}
                              fullWidth
                              type="date"
                              value={studentInfo.tentative_test_date || null}
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  tentative_test_date: e.target.value,
                                });
                                handleFieldChange(
                                  "tentative_test_date",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                                inputProps: {
                                  min: new Date().toISOString().split("T")[0],
                                },
                              }}
                              error={Boolean(errors.test_date)}
                              // helperText={errors.date_of_exam && 'Date of Exam is required'}
                            />
                          )}
                        />
                        {errors.date_of_exam && (
                          <span
                            style={{
                              color: "red",
                              position: "absolute",
                              top: 0,
                              right: -8,
                            }}
                          >
                            *
                          </span>
                        )}
                      </Grid>

                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Assumptive Proficiency Level
                        </Typography>
                        <Controller
                          name="assumptive_proficiency_level_id"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              select
                              {...field}
                              value={
                                studentInfo.assumptive_proficiency_level_id ||
                                null
                              }
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  assumptive_proficiency_level_id:
                                    e.target.value,
                                });
                                handleFieldChange(
                                  "assumptive_proficiency_level_id",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                              }}
                              fullWidth
                              error={Boolean(errors.proficiency_level)}
                              // helperText={errors.proficiency_level}
                            >
                              {proficiencyLevel.map((status) => (
                                <MenuItem key={status.id} value={status.id}>
                                  {status.english_proficiency}
                                </MenuItem>
                              ))}
                            </CustomTextFieldComp>
                          )}
                        />
                      </Grid>

                      <Grid item xs={6} md={4} lg={3}>
                        <Typography style={{ color: "black" }}>
                          Test Score
                        </Typography>
                        <Controller
                          name="target_score"
                          control={control}
                          render={({ field }) => (
                            <CustomTextFieldComp
                              size="normal"
                              {...field}
                              fullWidth
                              type="number"
                              value={studentInfo.target_score || null}
                              onChange={(e) => {
                                setStudentInfo({
                                  ...studentInfo,
                                  target_score: e.target.value,
                                });
                                handleFieldChange(
                                  "target_score",
                                  e.target.value,
                                );
                              }}
                              InputProps={{
                                style: { borderRadius: "10px" },
                                readOnly: isRecycledReadonly,
                              }}
                              error={Boolean(errors.target_score)}
                              //  helperText={errors.test_score }
                            />
                          )}
                        />
                        {errors.test_score && (
                          <span
                            style={{
                              color: "red",
                              position: "absolute",
                              top: 0,
                              right: -8,
                            }}
                          >
                            *
                          </span>
                        )}
                      </Grid>
                    </>
                  )}

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Ready to Enroll?</Typography>
                    <Controller
                      name="ready_to_enroll"
                      control={control}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={studentInfo.ready_to_enroll || null}
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              ready_to_enroll: e.target.value,
                            });
                            handleFieldChange(
                              "ready_to_enroll",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.ready_to_enroll)}
                          // helperText={errors.ready_to_enroll}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Level of Interest</Typography>
                    <Controller
                      name="level_of_interest_id"
                      control={control}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={studentInfo.level_of_interest_id || null}
                          onChange={(e) => {
                            setStudentInfo({
                              ...studentInfo,
                              level_of_interest_id: e.target.value,
                            });
                            handleFieldChange(
                              "level_of_interest_id",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.level_of_interest_id)}
                          // helperText={errors.proficiency_level_of_interest}
                        >
                          {levelOfInterest.map((status) => (
                            <MenuItem key={status.id} value={status.id}>
                              {status.level_of_interest}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>

                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">
                      Prospective Level
                      <span
                        style={{
                          color: "red",
                          position: "absolute",
                          marginLeft: "4px",
                          fontSize: "1em",
                        }}
                      >
                        *
                      </span>
                    </Typography>
                    <Controller
                      name="prospective_level_id"
                      control={control}
                      rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={
                            studentInfo.prospective_level_id?.id ||
                            studentInfo.prospective_level_id ||
                            null
                          }
                          onChange={(e) => {
                            handleProspectiveLevelChange(e.target.value);
                            setStudentInfo({
                              ...studentInfo,
                              prospective_level_id: e.target.value,
                            });
                            handleFieldChange(
                              "prospective_level_id",
                              e.target.value,
                            );
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.prospective_level_id)}
                          // helperText={errors.prospective_level}
                        >
                          {prospectiveLevel.map((status) => (
                            <MenuItem key={status.id} value={status.id}>
                              {status.prospective_level}
                            </MenuItem>
                          ))}
                        </CustomTextFieldComp>
                      )}
                    />
                    {errors.prospective_level_id && (
                      <span style={{ color: "red" }}>
                        {errors.prospective_level_id.message}
                      </span>
                    )}
                  </Grid>

                  {prospectiveLevelId === 5 && (
                    <Grid item xs={6} md={4} lg={3}>
                      <Typography variant="h6">
                        Recycle Reason
                        <span
                          style={{
                            color: "red",
                            position: "absolute",
                            marginLeft: "4px",
                            fontSize: "1em",
                          }}
                        >
                          *
                        </span>
                      </Typography>
                      <Controller
                        name="recycle_reason_id"
                        control={control}
                        rules={{ required: "Field is required" }}
                        render={({ field }) => (
                          <CustomTextFieldComp
                            size="normal"
                            select
                            {...field}
                            value={
                              studentInfo.recycle_reason_id?.id ||
                              studentInfo.recycle_reason_id ||
                              null
                            }
                            onChange={(e) => {
                              handleRecycleReasonChange(e.target.value);
                              setStudentInfo({
                                ...studentInfo,
                                recycle_reason_id: e.target.value,
                              });
                              handleFieldChange(
                                "recycle_reason_id",
                                e.target.value,
                              );
                            }}
                            InputProps={{
                              style: { borderRadius: "10px" },
                              readOnly: isRecycledReadonly,
                            }}
                            fullWidth
                            error={Boolean(errors.recycle_reason_id)}
                            // helperText={errors.prospective_level}
                          >
                            {recycledReasons.map((status) => (
                              <MenuItem key={status.id} value={status.id}>
                                {status.recycle_reason}
                              </MenuItem>
                            ))}
                          </CustomTextFieldComp>
                        )}
                      />
                      {errors.recycle_reason_id && (
                        <span style={{ color: "red" }}>
                          {errors.recycle_reason_id.message}
                        </span>
                      )}
                    </Grid>
                  )}
                </Grid>
              </Item>

              <Item>
                <Box display="flex" justifyContent="space-between" mb={2}>
                  <Typography id="assign" variant="h4" fontWeight={700}>
                    Assign
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography style={{ color: "black" }}>
                      Type Of Assignment
                    </Typography>
                    <Controller
                      name="assignment_type"
                      control={control}
                      render={({ field }) => (
                        <CustomTextFieldComp
                          size="normal"
                          select
                          {...field}
                          value={assignmentType}
                          onChange={(e) => {
                            setAssignmentType(e.target.value);
                            // handleFieldChange('ready_to_enroll', e.target.value)
                          }}
                          InputProps={{
                            style: { borderRadius: "10px" },
                            readOnly: isRecycledReadonly,
                          }}
                          fullWidth
                          error={Boolean(errors.assignment_type)}
                          // helperText={errors.ready_to_enroll}
                        >
                          <MenuItem value="permanent_assign">
                            Permanent Assignment
                          </MenuItem>
                          <MenuItem value="co_assignee">Co Assignment</MenuItem>
                        </CustomTextFieldComp>
                      )}
                    />
                  </Grid>
                  <Grid item xs={6} md={4} lg={3}>
                    <Typography variant="h6">Employee</Typography>
                    <Controller
                      name={
                        assignmentType === "co_assignee"
                          ? "co_assignee"
                          : "assign_to"
                      }
                      control={control}
                      // rules={{ required: "Field is required" }}
                      render={({ field }) => (
                        // <CustomTextFieldComp
                        //   select
                        //   {...field}
                        //   value={assignTo}
                        //   onChange={(e) => {
                        //     setAssignTo(e.target.value);
                        //     handleFieldChange(
                        //       assignmentType === "co_assignee"
                        //         ? "co_assignee"
                        //         : "assign_to",
                        //       e.target.value
                        //     );
                        //   }}
                        //   InputProps={{
                        //     style: { borderRadius: "10px" },
                        //     readOnly: isRecycledReadonly,
                        //   }}
                        //   fullWidth
                        //   error={Boolean(errors.assign_to)}
                        //   //helperText={errors.assign_to}
                        //   //value={ advisorId || ''}
                        // >
                        //   {taskOwners.map((item) => (
                        //     <MenuItem key={item.id} value={item.id}>
                        //       {item.first_name} {item.last_name}
                        //     </MenuItem>
                        //   ))}
                        // </CustomTextFieldComp>

                        <CustomAutocompleteComp
                          disableClearable
                          PopperComponent={StyledPopper}
                          disablePortal
                          value={assignTo}
                          options={taskOwners}
                          onChange={(event, value) => {
                            const id = value?.id;
                            setAssignTo(value);
                            handleFieldChange(
                              assignmentType === "co_assignee"
                                ? "co_assignee"
                                : "assign_to",
                              id,
                            );
                          }}
                          getOptionLabel={(option) =>
                            `${option.first_name ? option.first_name : ""} ${
                              option.last_name ? option.last_name : ""
                            }`
                          }
                          renderInput={(params) => (
                            <CustomTextFieldComp
                              {...params}
                              variant="outlined"
                              InputProps={{
                                ...params.InputProps,
                                style: { borderRadius: "10px" },
                              }}
                            />
                          )}
                          sx={{
                            "& .MuiAutocomplete-listbox": {
                              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                              width: 250,
                            },
                          }}
                        />
                      )}
                    />
                    {errors.assign_to && (
                      <span style={{ color: "red" }}>
                        {errors.assign_to.message}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={6} md={4} lg={6}>
                    <Typography sx={{ visibility: "hidden" }}>Save</Typography>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={handleSubmit(handleSaveStudentInfo)}
                      disabled={isRecycledReadonly}
                    >
                      Save
                    </Button>

                    <Button
                      variant="contained"
                      size="small"
                      style={{ marginLeft: "10px" }}
                      color={showAssignHistory ? "error" : "primary"}
                      onClick={handleToggleAssign}
                    >
                      {showAssignHistory
                        ? "Close Assign History"
                        : "View Assign History"}
                    </Button>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={4}
                        sm={6}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="h5" color="primary">
                          Permanent Assign :
                        </Typography>
                        <Typography variant="h5" ml={1}>
                          {enquiryData?.assign_to?.first_name}{" "}
                          {enquiryData?.assign_to?.last_name}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={6}
                        lg={4}
                        sm={6}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="h5" color="primary">
                          Co - Assign:
                        </Typography>
                        <Typography variant="h5" ml={1}>
                          {enquiryData?.co_assignee?.first_name}{" "}
                          {enquiryData?.co_assignee?.last_name}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  {showAssignHistory && (
                    <Grid item xs={12} md={12} lg={12} sm={12}>
                      <DataGrid
                        rows={assignData}
                        columns={columns}
                        autoHeight
                        getRowId={() => Math.floor(Math.random() * 100000000)}
                        slots={{
                          noRowsOverlay: CustomNoRowsOverlay,
                        }}
                        initialState={{
                          pagination: {
                            paginationModel: {
                              pageSize: 25,
                            },
                          },
                        }}
                        sx={{ marginTop: "20px" }}
                        pageSizeOptions={[25, 50, 100]}
                      />
                    </Grid>
                  )}
                </Grid>
              </Item>

              <Item>
                <Typography id="campaign" variant="h4" fontWeight={700}>
                  Campaign Detail
                </Typography>
                <CampaignDetail enquiryData={enquiryData} />
              </Item>

              <Item>
                <Typography id="qualification" variant="h4" fontWeight={700}>
                  Qualification Detail
                </Typography>
                <QualificationDetails
                  qualificationList={qualificationList}
                  onAddQualification={handleAddQualification}
                  onEditQualification={handleEditQualification}
                  onDeleteQualification={handleDeleteQualification}
                />
              </Item>

              <Item>
                <Typography id="event" variant="h4" fontWeight={700}>
                  Event Registration & Walk-ins
                </Typography>
                <EventRegistration enquiryData={enquiryData} />
              </Item>

              <Item>
                <div>
                  <Typography id="add-task" variant="h4" fontWeight={700}>
                    View Tasks
                  </Typography>
                  <ViewTaskDataGrid
                    isDialogOpen={isDialogOpen}
                    openDialog={openDialog}
                    closeDialog={closeDialog}
                    tasksData={tasksData}
                    studentId={enquiryId}
                    enquiryData={enquiryData}
                  />
                </div>
                <CustomPopup
                  open={isDemoPopupOpen}
                  onClose={handleCloseDemoPopup}
                  title="Book Demo"
                  maxWidth="md"
                  component={<EnquiryBookDemoForm enquiryData={enquiryData} />}
                />
              </Item>

              <Item>
                <Typography id="whatsapp" variant="h4" fontWeight={700}>
                  WhatsApp
                </Typography>
                <WhatsappMessages enquiryData={enquiryData} />
              </Item>

              <Item>
                <Typography id="email" variant="h4" fontWeight={700}>
                  Email
                </Typography>
                <Email enquiryData={enquiryData} />
              </Item>
            </Stack>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={2.9}
          lg={2.9}
          sm={12}
          style={{
            position: "sticky",
            top: 210,
            height: "65vh",
            // zIndex: 10,

            overflowY: "auto",
            // marginLeft: "5px",
            // textAlign: "center",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12} md={12} sm={12}>
              <Box
                sx={{
                  display: { xs: "none", lg: "flex", xl: "flex", md: "flex" },
                  flexWrap: "wrap",
                  p: 1,
                  rowGap: 1,
                  alignContent: "flex-start",
                  columnGap: 1,
                }}
              >
                <Link
                  to="personal-info"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Personal Info
                  </Button>
                </Link>

                <Link
                  to="contact-info"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Contact Info
                  </Button>
                </Link>

                <Link
                  to="mandatory_info"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Mandatory Info
                  </Button>
                </Link>

                <Link
                  to="test-info"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Test Details
                  </Button>
                </Link>

                <Link
                  to="assign"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Assign
                  </Button>
                </Link>

                <Link
                  to="campaign"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Campaign Details
                  </Button>
                </Link>

                <Link
                  to="qualification"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Qualification Details
                  </Button>
                </Link>

                <Link
                  to="add-task"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    View Tasks
                  </Button>
                </Link>

                <Link
                  to="event"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Event Registration & Walk-ins
                  </Button>
                </Link>

                <Link
                  to="whatsapp"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Whatsapp
                  </Button>
                </Link>

                <Link
                  to="email"
                  smooth={true}
                  duration={500}
                  offset={-headerHeight}
                >
                  <Button
                    size="small"
                    style={{
                      background: "white",
                      color: "black",
                      borderRadius: "8px",
                    }}
                  >
                    Email
                  </Button>
                </Link>
              </Box>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Accordion
                expanded={demoHistoryExpanded}
                onChange={handleDemoHistoryAccordionChange}
                style={{
                  border: `2px solid #2196F3`,
                  borderRadius: "10px",
                }}
              >
                <AccordionSummary>
                  <Typography variant="h4" fontWeight={700}>
                    Demo History
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box mt={2}>
                    <Grid container spacing={6}>
                      <Grid item xs={12} md={12}>
                        <DemoHistoryList
                          studentId={enquiryId}
                          demoHistory={demoHistory}
                          loading={demoLoading}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
              <Accordion
                expanded={activityExpanded}
                onChange={handleActivityAccordionChange}
                style={{
                  border: `2px solid #2196F3`,
                  borderRadius: "10px",
                }}
              >
                <AccordionSummary>
                  <Typography variant="h4" fontWeight={700}>
                    Notes
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <ViewNotesDataGrid
                        studentId={enquiryId}
                        userId={userId}
                        enquiryPersonalId={studentInfo?.enq_personal_detail_id}
                        studentInfo={studentInfo}
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        </Grid>

        <CustomPopup
          open={isRescheduleDemoPopupOpen}
          onClose={handleCloseRescheduleDemoPopup}
          title="Reschedule Demo"
          maxWidth="md"
          component={
            <EnquiryRescheduleDemoForm
              enquiryData={enquiryData}
              demoHistory={demoHistory}
            />
          }
        />

        <CreatePopup
          open={isDropOutRequest}
          onClose={handleCloseDropOutRequest}
          title="Drop out request"
          component={<DropOutRequest enquiryData={enquiryData} />}
        />

        <QualificationModal
          openQualification={openQualificationModal}
          setOpenQualification={setOpenQualificationModal}
          qualificationData={qualificationData}
          setQualificationData={setQualificationData}
          courseLevels={courseLevels}
          qualificationList={qualificationList}
          streams={streams}
          countriesList={countriesList}
          qualificationStates={qualificationStates}
          qualificationCities={qualificationCities}
          affiliations={affiliations}
          selectedQualification={selectedQualification}
          enquiryId={enquiryId}
          setQualificationList={setQualificationList}
          handleQualificationSave={handleQualificationSave}
          handleQualificationCountryChange={handleQualificationCountryChange}
          handleQualificationStateChange={handleQualificationStateChange}
        />

        <CustomSnackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
      </Grid>

      <CustomPopup
        open={gradlynkpopup}
        onClose={handleGrandlynkPopupclose}
        component={
          <GradlynkForm
            enquiryData={enquiryData}
            onClose={handleGrandlynkPopupclose}
          />
        }
        title="Add Gradlynk Service "
        maxWidth="sm"
        showDivider={true}
      />

      <CustomPopup
        open={isAddFeePopup}
        onClose={handleCloseAddFeePopup}
        title="Add Miscellaneous Fee"
        maxWidth="md"
        component={
          <AddMiscellaneousFees
            enquiryData={enquiryData}
            onClose={handleCloseAddFeePopup}
          />
        }
        showDivider={true}
      />
      <CustomPopup
        open={addServicePopup}
        onClose={handleCloseAddService}
        title="Add  Service"
        maxWidth="md"
        showDivider={true}
        component={
          <AddMoreServiceForm
            onClose={handleCloseAddService}
            studentInfo={studentInfo}
            showSnackbar={showSnackbar}
          />
        }
      />
    </div>
  );
}

export default ViewEnquiry;
